const diction = {
  "version": "1.0.1",
  "lang_order": ["option_key", "zh_CN", "zh_TW", "ja_JP", "en_US"],
  "desc": "key，简体中文，繁体中文，日文, 英文",
  "dict": {
    // 语言弹窗
    "lang": [
      ["lang_cn", "简体中文", "简体中文", "简体中文", "简体中文"],
      ["lang_tw", "繁體中文", "繁體中文", "繁體中文", "繁體中文"],
      ["lang_ja", "日本語", "日本語", "日本語", "日本語"],
      ["lang_en", "English", "English", "English", "English"],

      ["language", "简体中文", "繁体中文", "日本语", "English"]
    ],


    // 登入
    "login": [
      ["selectLanguage", "请选择语言", "請選擇語言", "言語をお選びください", "Please select a language"],
      ["startText", "将滑块滑动至最右", "將滑塊滑動至最右", "スライダーを一番右へ", "Slide to the right"],
      ["pwdLogin", "密码登入", "暗號登入", "パスワード", "Use Password"],
      ["codeLogin", "邮箱登入", "電郵登入", "メール認証", "Use E-mail"],
      ["enterEmail", "邮箱地址", "電郵位址", "メールアドレス", "E-mail Address"],
      ["enterPassword", "密码", "暗號", "パスワード", "Password"],
      ["enterCode", "验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["getCode", "获取验证码", "獲取驗證碼", "コード送信", "Sent Code"],
      ["enterImageCode", "验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["login", "登入", "登入", "ログイン", "Log In"],
      ["applyRegister", "申请注册新账号", "申請註冊新帳號", "新規アカウント申請", "Apply for Sign Up"],
      ["applyInfo", "申请注册新账号", "申請註冊新帳號", "新規アカウント申請", "Apply for Sign Up"],
      ["systemIntro", "了解我们", "了解我們", "私達に関して", "About Us"],
      ["systemInfo", "了解我们", "了解我們", "私達に関して", "About Us"],
      ["merchant2", "「隐私条款」", "「隱私條款」", "「プライバシーポリシー」", "「Privacy Policy」"],
      ["merchant1", "「用户协议」", "「用戶協議」", "「利用規約」", "「User Agreement」"],
      ["AgreeTips", "需先阅读并同意「用户协议」 | 「隐私条款」才能使用本系统", "需先閱讀並同意「用戶協議」 | 「隱私條款」才能使用本系統", "「ユーザー規約」 | 「プライバシーポリシー」をご覧の上同意してから利用可能となります", "Before using you should understand and agree 「User Agreement」 | 「Privacy Policy」"],

      ["successText", "成功", "成功", "できました", "Succeeded"],
      ["loginSuccess", "成功", "成功", "できました", "Succeeded"],
      ["errorLogin", "系统或网络出错，您未成功提交，请重新提交，给您造成不便十分抱歉", "系統或網絡出錯，您未成功提交，請重新提交，給您造成不便十分抱歉", "ご迷惑をおかけ申し訳ございませんが、システムまたはネットワークエラーで提出できませんでした。お手数ですが、再度ご提出ください", "Sorry, there was an error in the system or network, you did not submit successfully, please resubmit, sorry for the inconvenience caused to you"],
      ["noInput", "无法认证.  请确认信息填写正确", "無法認證.  請確認信息填寫正確", "認証できませんでした.  ご入力の情報が正しいかをご確認ください", "Cannot be verified.  Please confirm that information you fill in corrected"],
      ["enterLoginEmail", "无法认证.  请确认信息填写正确", "無法認證.  請確認信息填寫正確", "認証できませんでした.  ご入力の情報が正しいかをご確認ください", "Cannot be verified.  Please confirm that information you fill in corrected"],
      ["enterLoginPassword", "无法认证.  请确认信息填写正确", "無法認證.  請確認信息填寫正確", "認証できませんでした.  ご入力の情報が正しいかをご確認ください", "Cannot be verified.  Please confirm that information you fill in corrected"],
      ["noAccount", "无法认证.  请确认信息填写正确", "無法認證.  請確認信息填寫正確", "認証できませんでした.  ご入力の情報が正しいかをご確認ください", "Cannot be verified.  Please confirm that information you fill in corrected"],
      ["enterLoginEmail02", "邮箱与验证码不匹配.  无法完成验证", "郵箱與驗證碼不匹配.  無法完成驗證", "メールアドレスと認証コードがマッチできず.  認証が完了できません。", "The email address does not match the verification code.  and the verification cannot be completed"],
      ["errorCode", "邮箱与验证码不匹配.  无法完成验证", "郵箱與驗證碼不匹配.  無法完成驗證", "メールアドレスと認証コードがマッチできず.  認証が完了できません。", "The email address does not match the verification code.  and the verification cannot be completed"],
      ["emailError", "该邮箱账号不存在", "該郵箱賬號不存在", "このメールアドレスのアカウントが存在しません", "The Email account did not exist."],
      ["enterSliderStatus", "请完成滑块认证再行登入", "請完成滑塊認證再行登入", "スライダー認証を完成してください", "Please complete slide verification"],

      ["merchant", "隐私条款及用户协议", "隱私條款及用戶協議", "プライバシーポリシー及び利用規約", "Privacy Policy and User Agreement"],
      ["merchantBtn1", "返回", "返回", "戻る", "Go Back"],
      ["merchantBtn2", "我已阅读并同意", "我已閱讀並同意", "同意して次へ", "I agree"],
      ["enterStoreName", "请输入卖家名和您的姓名", "請輸入賣家名和您的姓名", "社名とお名前をご入力ください", "Please enter your seller’s name"],
      ["enterMobile", "请输入手机号码", "請輸入手机號碼", "携帯番号をご入力ください", "Please enter your cellphone number"],
      [
        "enterSimpleDesc",
        "请输入可联系的电邮位地址并简要说明无法验证的原因 (例如忘记了邮箱密码无法登录邮箱获取验证码等)",
        "請輸入可聯繫的電郵位地址並簡要說明無法驗證的原因 (例如忘記了電郵密碼無法登錄電郵獲取驗證碼等)",
        "連絡可能なメールアドレス及び認証できない理由等をご記入ください (例: メールアドレスの登入ができなくなったため認証コードの受信ができません)。",
        "Please fill in your e-mail address and describing the reason unable to verify  (e.g.:  I forget my email password that I can't log in to get a verification code)."
      ]
      ],


    "unsetLogin": [
      ["submitText", "确认并提交", "確認並提交", "確認して提出", "Submit"],
      ["backText", "返回", "返回", "戻る", "Go Back"],
      ["pageTitle", "无法验证?", "無法驗證?", "認証できない?", "Unable to Verify?"],
      ["tip", "请留下您的信息，我们会及时回复您。", "请留下您的信息您，我們會及時回復您。", "連絡先をご記入ください。順番になるべく早く対応いたしますのでしばらくお待ちください。", "Please enter your name and phone number, and we will respond as soon as possible. "], 
      ["success", "成功", "成功", "できました", "Succeeded"], 
    ],

    "register": [
      ["pageTitle", "申请注册新账号", "申請註冊新帳號", "新規アカウント申請", "Apply for Sign Up"],
      ["pageTip", " ", " ", " ", " "],
      ["edit", "编辑", "編輯", "編輯", "Edit"],
      ["title5", "申请状况", "申請狀況", "申請状況", "Application Situation"],
      ["btn1", "提交注册申请", "提交註冊申請", "申請する", "Submit"],
      ["title1", "属性", "屬性", "属性", "Attributes"],
      ["title2", "收款账户", "收款賬戶", "受取用口座", "Receipt Account"],
      ["title6", "付款账户", "付款賬戶", "支払用口座", "Payment Account"],
      ["title3", "补充", "補充", "別添", "Attachment"],
      ["title4", "账号", "賬號", "アカウント", "Account"],
      ["getCode", "获取验证码", "獲取驗證碼", "コード送信", "Sent Code"],
      ["gettingCode", "发送中", "發送中", "送信中", "Sending"],
      ["noEmail", "无法认证.  请确认信息填写正确", "無法認證.  請確認信息填寫正確", "認証できませんでした.  ご入力の情報が正しいかをご確認ください", "Cannot be verified.  Please confirm that information you fill in corrected"],
    ],

    "merchantForm": [
      ["name", "卖家名称", "卖家名稱", "販売業者名", "Name of Seller"],
      ["namePronunciation", "卖家名称拼音", "卖家名稱拼音", "販売業者名読み方", "Pronunciation of Seller Name"],
      ["mobile", "紧急联络方式", "緊急聯絡方式", "緊急連絡先", "Emergency Contact"],
      ["admin_name", "负责人姓名", "負責人姓名", "担当者名前", "Name (Person in Charge)"],
      ["admin_mobile", "负责人电话", "負責人電話", "担当者電話番号", "Phone No. (Person in Charge):"],
      ["admin_email", "负责人邮箱", "負責人電郵", "担当者メール", "E-mail (Person in Charge)"],
      ["districtcode", "联系地址", "聯繫地址", "連絡先住所", "Contact Address"],
      ["province", "国家地区, 省份等(例: 日本国東京都)", "國家地區, 省份等(例: 日本国東京都)", "国か地域, 都道府県等(例: 日本国東京都)", "Country or Region, State, Province(E.g.: Japan, Tokyo)"],
      ["city", "地方市区县乡街道等(例: 新宿区)", "地方市區縣鄉街道等(例: 新宿区)", "市区町村等(例: 新宿区)", "Municipalities, City (E.g.: Shinjyuku-ku)"],
      ["area", "路名小区门牌号等(例: 西新宿1-33-1)", "路名小區門牌號等(例: 西新宿1-33-1)", "町名番地号等(例: 西新宿1-33-1)", "Street, number, etc. (E.g.: Nishishinjyuku 1-33-1)"],
      ["addres", "其他：如建筑名公司名房间号(选填、例: Mini Station 101) ", "其他：如建築名公司名房間號(選填、例: Mini Station 101)", "その他: 建物や社名部屋番号等(あれば、例:ミニステーション101)", "Others: building, room number, etc. (Option、 E.g.: Mini Station 101)"],

      ["des", "主要业务内容", "主要業務內容", "主な業務内容", "Business Contents"],

      ["email", "账号邮箱", "賬號電郵", "アカウントメール", "Account E-mail"],
      ["emailCode","验证码", "驗證碼", "認証コード", "Verification Code"],
      ["password", "密码", "暗號", "パスワード", "Password"],
      ["rePassword", "密码确认", "暗號確認", "パスワード再入力", "Password Reenter"],

      ["financialInstitutionCode", "金融机构编码", "金融機構編碼", "金融機関コード", "Financial Institution Code"],
      ["financialInstitutionName", "金融机构名称", "金融機構名稱", "金融機関名", "Financial Institution Name"],
      ["branchCode", "支店编码", "支店編碼", "支店コード", "Branch Code"],
      ["branchName", "支店名称", "支店名稱", "支店名", "Branch Name"],
      ["accountType", "账户科目", "賬戶科目", "口座科目", "Account Type"],
      ["accountNo", "账户号码", "賬戶號碼", "口座番号", "Account Number"],
      ["accountName", "账户名义人", "賬戶名義人", "口座名義", "Account Holder"],
      ["address", "金融机构地址", "金融機構地址", "金融機関住所", "Financial Institution Address"],
      ["remark", "备注", "備註", "備考", "Note"],

      ["creareTime", "申请时间", "申請時間", "申請時間", "Application Time"],
      ["detailStatus", "状态", "狀態", "状態", "Status"],
      ["detailEmail",  "账号邮箱", "賬號電郵", "アカウントメール", "Account E-mail"],
      ["id", "案件 ID", "案件 ID", "ケースID", "Case ID"],
      ["status0", "审核中", "審査中", "審査中", "Reviewing"],

      ["status1", "已通过", "已通過", "承認済", "Approved"],
      ["status2", "已驳回", "已駁回", "却下済", "Rejected"],
      ["reason", "说明", "說明", "説明", "Directions"],



      ["editTitle", "编辑主账号", "編輯主賬號", "メインアカウント編輯", "Edit Main Account"],



      // 2022-11-15新增
      ["payWay", "支付方式(C)", "支付方式(C)", "支払方法(C)", "Payment Method(C)"],
      ["payWay1", "两者都可", "兩者都可", "両方可能", "Both"],
      ["payWay2", "仅限现金", "僅限現金", "現金のみ", "Cash Only"],
      ["payWay3", "现金以外", "現金以外", "現金以外", "Except Cash"],
    ],


    "merchant": [
      ["reTitle", "收款账户", "收款賬戶", "受取用口座", "Receipt Account"],
      ["payTitle", "付款账户", "付款賬戶", "支払用口座", "Payment Account"],
      ["detailTitle", "补充", "補充", "別添", "Attachment"],

      ["createTime", "时间", "時間", "時間", "Time"],
      ["id", "ID", "ID", "ID", "ID"],
      ["merchantName", "名称", "名稱", "名称", "Name"],
      ["namePronunciation", "名称拼音", "名稱拼音", "名称読み方", "Pronunciation of Name"],
      ["address", "地址", "地址", "住所", "Address"],
      ["status0", "审核中", "審核中", "審査中", "Reviewing"],
      ["status1", "正常", "正常", "正常", "Normal"],
      ["status2", "已驳回", "已駁回", "却下済", "Rejected"],
      ["status3", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["status4", "解约中", "解約中", "解約中", "Terminating"],
      ["status5", "冻结中-审核中", "凍結中-審核中", "ロック中-審査中", "Blocked- Reviewing"],
      ["status6", "已解约", "已解約", "解約済", "Terminated"],
      ["membershipFee", "现会费(円/月)", "現會費(円/月)", "現会費(円/月)", "Plan Fee (円/ Month)"],
      ["deleteTime", "解约时间", "解約時間", "解約時間", "Termination Time"],
      ["email", "邮箱验证", "電郵驗證", "メール認証", "E-mail Verify."],
      ["attributes","属性", "屬性", "属性", "Attributes"],
    ],



    "merchantRule": [
      ["name", "请输入组织名称或个人姓名", "請輸入組織名稱或個人姓名", "組織名か個人名をご入力ください", "Please enter your name"],
      ["namePronunciation", "请输入英文字母拼音", "請輸入英文字母拼音", "ローマ字表記でご入力ください", "Please enter with alphabet"],
      ["mobileEmergency", "请输入用于紧急联络的手机号码", "請輸入用於緊急聯絡的手機號碼", "緊急時の連絡用携帯番号をご入力ください", "Please enter cellphone number for emergency contacting"],
      ["mobile", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["admin_name", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["admin_mobile", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["admin_email", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["districtcode", "邮政编码", "郵政編碼", "郵便番号", "Zip Code"],
      ["province", "都道府県", "都道府県", "都道府県", "都道府県"],
      ["city", "市区町村", "市区町村", "市区町村", "市区町村"],
      ["area", "町名番地号", "町名番地号", "町名番地号", "町名番地号"],
      ["addres", "详细住址", "詳細住址", "その他", "Other"],
      ["email_please", "账号邮箱地址", "賬號電郵位址", "アカウントメールアドレス", "Accountmail Address"],
      ["email", "账号邮箱地址", "賬號電郵位址", "アカウントメールアドレス", "Accountmail Address"],
      ["emailCode_please", "验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["adminCode", "验证码", "驗證碼", "認証コード", "Verify. Code"],

      ["password", "密码(>=6位，含英字及数字)", "暗號(>=6位，含英字及數字)", "パスワード(>=6桁、英字と数字混在)", "Password(>=6 digits, incl. letter & No.)"],
      ["password2", "请再次输入密码", "請再次輸入暗號", "再度パスワードをご入力ください", "Please enter password again"],
      ["emailCode", "验证码", "驗證碼", "認証コード", "Verify. Code"],

      ["emailError_1", "该邮箱已被注册或不存在，无法验证", "該郵箱已被註冊或不存在，無法驗證", "このメールアドレスが登録されているか、存在しませんので、認証できません。", "Because the E-mail address was used or not existing, it cannot be verified."],
      ["rePassword", "两次输入的密码不一致", "兩次輸入的暗號不一致", "入力されたパスワードが一致しません", "The passwords entered twice do not match"],
      ["noEmail", "无法认证.  请确认信息填写正确", "無法認證.  請確認信息填寫正確", "認証できませんでした.  ご入力の情報が正しいかをご確認ください", "Cannot be verified.  Please confirm that information you fill in corrected"],
      ["emailEroor", "无法认证.  请确认信息填写正确", "無法認證.  請確認信息填寫正確", "認証できませんでした.  ご入力の情報が正しいかをご確認ください", "Cannot be verified.  Please confirm that information you fill in corrected"],



      ["financialInstitutionCode", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["financialInstitutionName", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["branchCode", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["branchName", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["accountType", "请选择", "請選擇", "お選びください", "Please Select"],
      ["accountNo", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["accountName", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["address", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["noBranchName", "若有其他转账时所需信息则请输入", "若有其他轉帳時所需信息則請輸入", "必要であればご入力ください", "Please enter if it is necessary"],
      ["remake", "若有其他转账时所需信息则请输入", "若有其他轉帳時所需信息則請輸入", "必要であればご入力ください", "Please enter if it is necessary"],

      ["files", " ", " ", " ", " "],
      ["idCode", " ", " ", " ", " "],
      ["noFile", " ", " ", " ", " "],


      ["des", "请概述主要业务内容(300字内)", "請概述主要業務內容(300字内)", "主な業務内容の概要をご記入ください(300文字内)", "Please enter your business contents(within 500 letters)"],




      ["oldCode", "原邮箱验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["newEmail", "新账号邮箱地址", "新賬號電郵位址", "新アカウントメールアドレス", "New Accountmail Address"],
      ["newCode", "新邮箱验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["newPassword", "新密码(>=6位，含英字及数字)", "新暗號(>=6位，含英字及數字)", "新パスワード(>=6桁、英字と数字混在)", "New Password(>=6 digits, incl. letter & No.)"],
      ["passwordMin", "密码(>=6位，含英字及数字)", "暗號(>=6位，含英字及數字)", "パスワード(>=6桁、英字と数字混在)", "Password(>=6 digits, incl. letter & No.)"],
      ["passwordRule", "密码(>=6位，含英字及数字)", "暗號(>=6位，含英字及數字)", "パスワード(>=6桁、英字と数字混在)", "Password(>=6 digits, incl. letter & No.)"],
      ["newRePassword", "请再次输入密码", "請再次輸入暗號", "再度パスワードをご入力ください", "Please enter password again"]
    ],



    "merchantDetail": [
      ["close", "申请解约", "申請解約", "解約申請", "Apply for Termination"],
      ["menu1", "账号安全", "賬號安全", "セキュリティ", "Security"],
      ["menu2", "基本", "基本", "基本", "Basic"],
      ["menu3", "合约", "合約", "契約", "Contract"],
      ["menu4", "记录", "記錄", "記錄", "Record"],
      ["sure","确认修改","確認修改","変更する","OK"],
      ["check","账号验证","賬號驗證","アカウント認証","Verify Account"],
      ["setPassWord", "修改密码", "修改暗號", "パスワード変更", "Change Password"],
      ["editMainEmailTitle", "修改主账号邮箱", "修改主賬號電郵", "メインアカウントメール変更", "Change Main Accountmail"],
      ["noVerif", "无法验证？", "無法驗證？", "認証できない？", "Unable to Verify？"],
      ["oldEmail", "原账号邮箱地址", "原賬號電郵位址", "元アカウントメールアドレス", "Old Accountmail Address"],
      ["mianEmail", "主账号邮箱", "主賬號電郵", "メインアカウントメール", "Main Accountmail"],
      ["newEmail", "新账号邮箱地址", "新賬號電郵位址", "新アカウントメールアドレス", "New Accountmail Address"],
      ["email", "邮箱地址", "電郵位址", "メールアドレス", "Email Address"],
      ["password", "新密码(>=6位，含英字及数字)", "新暗號(>=6位，含英字及數字)", "新パスワード(>=6桁、英字と数字混在)", "New Password(>=6 digits, incl. letter & No.)"],
      ["newRePassword", "请再次输入密码", "請再次輸入暗號", "再度パスワードをご入力ください", "Please enter password again"],


      ["frozen", "申请解冻", "申請解凍", "ロック解除申請", "Apply for Unblock"],
      ["frozening", "申请解冻中", "申請解凍中", "ロック解除申請中", "Applying for Unblock"],
      ["confirmFrozen", "撤销申请", "撤銷申請", "申請撤回", "Revoke Application"],
      ["closeTitle", "是否确定申请解约？成功解约后您将无法再使用此账号及其所有子账号。", "是否確定申請解約？成功解約後您將無法再使用此賬號及其所有子賬號。", "解約を申請しますがよろしいでしょうか？解約完了後、このアカウント及びその全ての関連アカウントが利用できなくなるので、ご了承ください。", "Are you sure to apply for account cancellation? Please note that you will not be able to use the account and its related account after the cancellation is completed."],
      ["thawTitle", "是否确定申请解冻?", "是否確定申請解凍?", "ロック解除を申請しますがよろしいでしょうか?", "Are you sure to apply for Unblock?"],
      ["revoke", "撤销申请", "撤銷申請", "申請撤回", "Revoke Request"],
      ["revokeTitle", "是否确定撤销申请?", "是否確定撤銷申請?", "撤回しますがよろしいでしょうか?", "Are you sure to revoke the application?"],
    ],



    "reportDoc": [
      ["selectPlaceholder", "报表类型", "報表類型", "レポートタイプ", "Report Type"],
      ["financialReport", "运营财务报告", "運營財務報告", "運営財務レポート", "Operating Finance Report"],
      ["inventoryReport", "交易明细报告", "交易明細報告", "取引明細レポート", "Transaction Detail Report"],
      ["circulationReport", "流通明细报告", "流通明細報告", "流通明細レポート", "Distribution Detail Report"],
      ["voucherReport", "收据", "收據", "領収書", "Invoice"],
      ["totalDetails", "运营凭据", "運營憑據", "運営書", "Operational Credentials"],


      ["createTime", "发行日", "發行日", "発行日", "Date of Issue"],
      ["createTime2", "发行时间", "發行時間", "発行時間", "Issue Time"],

      ["userId", "卖家ID", "賣家ID", "セラーID", "Seller ID"],
      ["merchantStoreOnlyId", "店铺ID", "店鋪ID", "ストアID", "Store ID"],

      ["times", "期间", "期間", "期間", "Period"],
      ["time", "下单时间", "下單時間", "注文時間", "Order Time"],
      ["time2", "运营期间", "運營期間", "運営期間", "Operation Time"],
      ["loginNum", "登录番号", "登錄番號", "登録番号", "Register No"],
      ["totalPriceTax", "合计金额(含税)", "合計金額(含稅)", "合計金額(税込)", "Total Amount (tax included)"],
      ["yongtu", "用途:  EC服务手续费", "用途:  EC服務手續費", "但し: ECサービス手数料", "for: EC Service Fee"],
      ["in", "其中", "其中", "内訳", "Detail"],
      ["txtBefore", "当社证明当下确认的在报告期间内贵社通过", "當社證明當下確認的在報告期間內貴社通過", "当社は現時点において、貴社が報告期間内に、", "We certifies that the transaction information of yours through the platform"],
      ["txtAfter", "平台发生的交易信息如下", "平台發生的交易信息如下", "を通した取引情報は以下の通りであることを報告する", " during the reporting period confirmed at the moment is as follows"],

      ["rateType", "税率区分", "稅率區分", "税率区分", "Tax Rate"],
      ["receiptPrice", "金额(円)", "金額(円)", "金額(円)", "Amount(円)"],
      ["taxRatePrice", "税额(円)", "稅額(円)", "税額(円)", "Tax(円)"],

      ["startBalance", "期初余额(円)", "期初餘額(円)", "期首残高(円)", "Opening Balance(円)"],
      ["salesIncomePrice", "含税销量(円)", "含稅銷量(円)", "税込売上(円)", "Tax-included Sales(円)"],
      ['otherIncomePrice',"其他收入(円)","其他收入(円)","其他収入(円)","Other Income(円)"],
      ["serviceExpensePrice", "服务费支出(円)", "服務費支出(円)", "支払手数料(円)", "Service Fee(円)"],
      ["otherExpensePrice", "其他支出(円)", "其他支出(円)", "其の他支出(円)", "Other Expenditure"],
      ['periodicRecharge',"期间充值(円)","期間充值(円)","期間預入(円)","Recharge Period(円)"],
      ['periodicWithdrawal',"期间提现(円)","期間提現(円)","期間引出(円)","Withdraw Period(円)"],

      ["InventoryList", "库存总表", "庫存總表", "在庫棚卸表", "Inventory List"],
      ['movementDetailList','流转明细表','流轉明細表','移動明細表','Movement Detail List'],

      ["yongtu02", "用途", "用途", "但し", "for"],
      ["payment", "支付方式", "支付方式", "支払方法", "Payment"],
      ["project", "项目", "項目", "項目", "Item"],
      ["CreditCard", "信用卡", "信用卡", "クレジットカードです", "Credit card"],
      ["Cash", "现金", "現金", "現金", "Cash"],
      ["FreePayment", "免费支付", "免費支付", "無料で支払います", "Free payment"],
    ],



    "finance": [
      ["title1", "损益部分", "損益部分", "損益の部", "Profit and Loss"],
      ["title2", "余额部分", "餘額部分", "残高の部", "Balance"],

      ["salesIncomePrice", "销售", "銷售", "販売", "Sale Benefit"],
      ["inventoryLossIncomePrice", "盘亏补贴", "盤虧補償", "異常補填", "Loss Compensation"],
      ["otherIncomePrice", "其他", "其他", "其他", "Other"],
      ["totalIncome", "收入合计", "收入合計", "収入合計", "Total income"],

      ["logisticsServiceExpensePrice", "流通服务费", "流通服務費", "流通手数料", "Distribution Fee"],
      ["salesServiceExpensePrice", "销售服务费", "銷售服務費", "販売手数料", "Commission Fee"],
      ["merchantRentExpensePrice", "卖家会费", "賣家會費", "セラー会費", "Seller Membership Fee"],
      ["storeRentExpensePrice", "店铺赁费", "店鋪賃費", "ストア賃料", "Store Rent Fee"],
      ["afterServiceExpensePrice", "售后服务费", "售後服務費", "返金手数料", "Refund Fee"],
      ["premiumExpensePrice", "保费", "保費", "プレミアム費", "Premium Fee"],
      ["makeExpensePrice", "商品处理费", "商品處理費", "商品処分手数料", "Inventory Disposal Fee"],
      ["settleServiceExpensePrice", "结算手续费", "結算手續費", "決済手数料", "Payment Fee"],
      ["promotionExpensePrice", "推广费", "推廣費", "プロモーション費", "Promotion Fee"],
      ["payIncomePrice", "费用合计", "費用合計", "費用合計", "Total Expenditure"],
      ["basicProfitLoss", "基本损益", "基本損益", "基本損益", "Basic Profit and Loss"],

      ["startBalance", "期初总余额", "期初總餘額", "期首合計残高", "Total Balance Beginning"],
      ["periodicRecharge", "充值", "充值", "チャージ", "Payment"],
      ["periodicWithdrawal", "提现", "提現", "ペーメント", "Recharge"],
      ["endBalance", "期末总余额", "期末總餘額", "期末合計残高", "Total Balance Ending"],
      ["endFrozenBalance", "期末冻结中余额", "期末凍結中餘額", "期末ブロック中残高", "Frozen Balance Ending"],
      ["endWithLoadBalance", "期末提现中余额", "期末提現中餘額", "期末引出中残高", "Withdrawing Balance Ending"],
      ["endWithBalance", "期末可提现余额", "期末可提現餘額", "期末引出可能残高", "Withdrawable Balance Ending"],


    ],



    "circulation": [
      ["num1", "期首库存", "待翻译", "待翻译", "待翻译"],
      ["stockIn", "入库", "入庫", "入庫", "Stock In"],
      ["num3", "销售出库", "待翻译", "待翻译", "待翻译"],
      ["num4", "其他出库", "待翻译", "待翻译", "待翻译"],
      ["num5", "转运出库", "待翻译", "待翻译", "待翻译"],
      ["num6", "销毁出库", "待翻译", "待翻译", "待翻译"],
      ["num7", "差异出库", "待翻译", "待翻译", "待翻译"],

    ],


    "payment": [
      ["num1", "期首库存", "待翻译", "待翻译", "待翻译"],
      ["num2", "入库", "待翻译", "待翻译", "待翻译"],
      ["num3", "销售出库", "待翻译", "待翻译", "待翻译"],
      ["num4", "其他出库", "待翻译", "待翻译", "待翻译"],
      ["num5", "转运出库", "待翻译", "待翻译", "待翻译"],
      ["num6", "销毁出库", "待翻译", "待翻译", "待翻译"],
      ["num7", "差异出库", "待翻译", "待翻译", "待翻译"],
      ["key", "日期", "待翻译", "待翻译", "待翻译"],
      ["key", "类别", "待翻译", "待翻译", "待翻译"],
      ["key", "内容", "待翻译", "待翻译", "待翻译"],
      ["num", "数量", "數量", "数量", "Number"],
      ["key", "单价", "待翻译", "待翻译", "待翻译"],
      ["key", "总金额", "待翻译", "待翻译", "待翻译"],
      ["key", "交易后金额", "待翻译", "待翻译", "待翻译"],
      ["get1", "商品销售", "待翻译", "待翻译", "待翻译"],
      ["get2", "提现", "待翻译", "待翻译", "待翻译"],
      ["get3", "盘亏赔偿", "待翻译", "待翻译", "待翻译"],
      ["pay1", "充值", "待翻译", "待翻译", "待翻译"],
      ["pay2", "申请提前结算手续费", "待翻译", "待翻译", "待翻译"],
      ["pay3", "广告费", "待翻译", "待翻译", "待翻译"],
      ["pay4", "销售运费", "待翻译", "待翻译", "待翻译"],
      ["pay5", "销售手续费", "待翻译", "待翻译", "待翻译"],
      ["pay6", "平台会费", "待翻译", "待翻译", "待翻译"],
      ["pay7", "售后手续费", "待翻译", "待翻译", "待翻译"],
      ["pay8", "平台物流运费", "待翻译", "待翻译", "待翻译"],
      ["pay9", "保费支出", "待翻译", "待翻译", "待翻译"],
      ["pay10", "商品处理运费", "待翻译", "待翻译", "待翻译"],
      ["special", "余额结算", "待翻译", "待翻译", "待翻译"],
      ["specia2", "结余", "待翻译", "待翻译", "待翻译"],
      ["type0", "前期结余", "待翻译", "待翻译", "待翻译"],
      ["type1", "收款", "待翻译", "待翻译", "待翻译"],
      ["type2", "收益", "待翻译", "待翻译", "待翻译"],
      ["type3", "费用", "待翻译", "待翻译", "待翻译"],
      ["type4", "付款", "待翻译", "待翻译", "待翻译"],
      ["type5", "提现", "待翻译", "待翻译", "待翻译"],
      ["type6", "充值", "待翻译", "待翻译", "待翻译"],

    ],




    "backMain": [
      // 左上角logo旁边的标题
      ["logoTitle", "卖家中心", "賣家中心", "セラーセントラル", "Seller Central"],


      // 左侧菜单 start ----------------------------------
      ["menu0", "设置", "設置", "セッティング", "Setting"],
      ["menu0_1", "展厅布置", "展廳佈置", "ショールーム", "Showroom"],

      ["menu2", "运营", "運營", "運営", "Operation"],
      ["menu2_3", "设置", "設置", "セッティング", "Setting"],
      ["menu2_1", "店铺信息管理", "待翻译", "待翻译", "待翻译"],
      ["menu2_2", "商品", "商品", "アイテム", "Item"],
      ["menu2_4", "内容", "內容", "コンテンツ", "Contents"],
      ["menu2_5", "评价", "評價", "レビュー", "Review"],
      ["menu2_6", "优惠券", "優惠券", "クーポン", "Coupon"],
      ["menu2_7", "下单选项", "下單選項", "オーダーオプション", "Order Option"],

      ["menu4", "消息", "消息", "メッセージ", "Message"],
      ["menu4_1", "提示", "提示", "リマインド", "Reminder"],
      ["menu4_2", "公告", "公告", "アナウンス", "Announce"],
      ["menu4_3", "MLL 小二", "MLL 小二", "MLL コンシェルジュ", "MLL Concierge"],
      ["menu4_4", "联系顾客", "聯系顧客", "カスタマーチャット", "Customer Chat"],

      ["menu3", "订单", "訂單", "注文", "Order"],
      ["menu3_1", "商城-通常订单(待接单)", "商城-通常訂單(待接單)", "モール-通常注文(確認待ち)", "Mall-Usually Order (for Confirm.)"],
      ["menu3_2", "商城-通常订单(待取货)", "商城-通常訂單(待取貨)", "モール-通常注文(受取待ち)", "Mall-Usually Order (for Pickup.)"],
      ["menu3_3", "商城-通常订单(其他)", "商城-通常訂單(其他)", "モール-通常注文(その他)", "Mall-Usually Order (Other)"], 
      ["menu3_7", "商城-线下交付(待处理)", "商城-線下交付(待處理)", "モール-オフライン(対応待ち)", "Mall-Offline (for Process.)"],
      ["menu3_7_1", "商城-线下交付(其他)", "商城-線下交付(其他)", "モール-オフライン(その他)", "Mall-Offline (Other)"], 
      ["menu3_4", "商城-售后", "商城-售後", "モール-返金", "Mall- Refund"],
      ["menu3_4_1", "商城-售后(待处理)", "商城-售後(待處理)", "モール-返金(対応待ち)", "Mall- Refund (for Process.)"], // 商城-售后(待处理)	商城-售後(待處理)	モール-返金(対応待ち)	Mall- Refund (for Process.)
      ["menu3_4_2", "商城-售后(其他)", "商城-售後(其他)", "モール-返金(その他)", "Mall- Refund (Others)"], // 商城-售后(其他)	商城-售後(其他)	モール-返金(その他)	Mall- Refund (Other)
      ["menu3_5", "流通-入系", "流通-入系", "流通-入系", "Distribution-Insys"],
      ["menu3_5_1", "流通-入系(待接单)", "流通-入系(待接單)", "流通-入系(確認待ち)", "Distribution-Insys(for Confirm.)"], // 流通-入系(待接单)	流通-入系(待接單)	流通-入系(確認待ち)	Distribution-Insys (for Confirm.)
      ["menu3_5_2", "流通-入系(待取货)", "流通-入系(待取貨)", "流通-入系(受取待ち)", "Distribution-Insys(for Pickup.)"], // 流通-入系(待取货)	流通-入系(待取貨)	流通-入系(受取待ち)	Distribution-Insys (for Pickup.)
      ["menu3_5_3", "流通-入系(其他)", "流通-入系(其他)", "流通-入系(その他)", "Distribution-Insys(Others)"], // 流通-入系(其他) 	流通-入系(其他)	流通-入系(その他)	Distribution-Insys (Others)
      ["menu3_6", "推广-站内推送", "推廣-站內推送", "プロモ-アプリ押", "Promotion- App. Push"], 


      ["menu5", "我的", "我的", "マイページ", "Mypage"],
      ["menu5_2", "角色", "角色", "ロール", "Role"],  // 合并到“账号”模块
      ["menu5_4", "主账号详情", "主賬號詳情", "メインアカウント詳細", "Main Account Details."],  // 合并到“账号”模块
      ["menu5_3", "账号", "賬號", "アカウント", "Account"],
      ["menu5_1", "店铺", "店鋪", "ストア", "Store"],
      ["menu5_5", "钱包", "錢包", "ウォレット", "Wallet"],
      ["menu5_7", "一般", "一般", "ジェネラル", "General"],
      ["menu5_6", "数据盘", "數據盤", "ダッシュボード", "Dashboard"],
      ["menu5_9", "报表", "報表", "レポート", "Report"],
      ["menu5_8", "指南", "指南", "マニュアル", "Manual"],

      ["menu1", "首页", "首頁", "ホーム", "Home"]

    ],


    "index": [
      ["title1", "展厅", "展廳", "ショールーム", "Showroom"], // 推送内容
      ["title2", "门面图片", "門面圖片", "正面看板", "Facade Sign"], // 店铺首页背景图
      ["delBackground", "是否确定删除该门面图片?", "是否確定刪除該門面圖片?", "この正面看板を削除しますがよろしいでしょうか?", "Are you sure to delete this  facade sign?"], // 删除店铺首页背景图
      ["delLogo", "是否确定删除该店铺图标?", "是否確定刪除該店鋪圖標?", "このストアロゴを削除しますがよろしいでしょうか?", "Are you sure to delete this store logo?"], // 删除店铺图标
      ["title3", "内容推送", "內容推送", "おすすめコンテンツ", "Featured Contents"],
      ["title4", "商品推送", "商品推送", "おすすめアイテム", "Featured Items"],
      ["title5", "分类", "分類", "カテゴリ", "Category"], // 商品分类
      ["title6", "入口", "入口", "入口", "Entrance"], // 店铺入口
      ["title6_1", "流通类型", "流通類型", "流通類型", "Distribution Type"],
      ["title6_head1", "添加入口", "添加入口", "入口追加", "Add Entrance"],
      ["title6_head2", "编辑入口", "編輯入口", "入口編輯", "Edit Entrance"],
      ["title6_del", "是否确定删除该入口?", "是否確定刪除該入口?", "この入口削除しますがよろしいでしょうか?", "Are you sure to delete this entrance?"],
      ["title7", "名称", "名稱", "名称", "Name"],
      ["title8", "选项", "選項", "オプション", "Option"],
      ["title9", "选项名称", "选项名称", "オプション名称", "Option Name"],
      ["title10", "二维码", "二維碼", "QRコード", "QR Code"],


      ["goodsType1", "A: 事先集运", "A: 事先集運", "A: 事前集荷", "A: Take before"],
      ["goodsType2", "B: 外送", "B: 外送", "B: 出前", "B: Take after"],
      ["goodsType3", "C: 线下交付", "C: 線下交付", "C: オフライン", "C: Offline Trade"],


      ["pushNum", "编号", "編號", "番号", "No."],
      ["goodsId", "编号", "編號", "番号", "No."],
      ["pushPosition", "推送位置", "推送位置", "表示場所", "Display Place"],
      ["dialogTitle1", "添加内容推送", "添加內容推送", "おすすめコンテンツ追加", "Add Featured Contents"],
      ["dialogTitle2", "添加商品推送", "添加商品推送", "おすすめアイテム追加", "Add Featured Items"],
      ["dialogTitle3", "添加分类", "添加分類", "カテゴリ追加", "Create a Category"],
      ["dialogTitle4", "转移商品", "轉移商品", "商品移転", "Transfer Item"],
      ["dialogTitle5", "编辑分类", "編輯分類", "カテゴリ編輯", "Edit Category"],
      ["cagegoryType", "级别", "級別", "階層", "Hierarchy"],
      ["cagegoryName", "名称", "名稱", "名称", "Name"], // 分类名称
      ["parentId", "上级分类", "上級分類", "親カテゴリ", "Affiliation Category"],
      ["cateType1", "1级", "1級", "1階", "Primary"],
      ["cateType2", "2级", "2級", "2階", "Secondary"],
      ["ruleParentId", "请选择", "請選擇", "お選びください", "Please Select"], // 请选择上级分类
      ["goodsNum", "商品数", "商品數", "アイテム数", "Number of Items"],
      ["noPushId", "请输入内容ID", "請輸入內容ID", "コンテンツIDをご入力ください", "Please enter the contents ID"],
      ["noPushId2", "请输入商品ID", "請輸入商品ID", "アイテムIDをご入力ください", "Please enter the item ID"],
      ["goodsChangeType", "现分类", "現分類", "現カテゴリ", "Current Affiliation"], // 当前上级分类
      ["goodsChangeType2", "移动至", "移動至", "移転先", "Change to"], // 选择转移分类
      ["noChangeNewId", "请选择", "請選擇", "お選びください", "Please select"],
      ["noChaneSonNewId", "请选择", "請選擇", "お選びください", "Please select"],



      ["ruleCagegoryName", "信息填写不符合要求，请确认要求并完善信息", "信息填寫不符合要求，請確認要求並完善信息", "入力された情報が要件を満たしていません. お手数ですが、ご確認の上修正してください", "The information filled in does not meet the requirements.  Please confirm the requirements and modify the information"], // 请输入分类名称
      ["ruleNoinput", "信息填写不符合要求，请确认要求并完善信息", "信息填寫不符合要求，請確認要求並完善信息", "入力された情報が要件を満たしていません. お手数ですが、ご確認の上修正してください", "The information filled in does not meet the requirements.  Please confirm the requirements and modify the information"], // 请输入分类名称
      ["noInput", "信息填写不符合要求，请确认要求并完善信息", "信息填寫不符合要求，請確認要求並完善信息", "入力された情報が要件を満たしていません. お手数ですが、ご確認の上修正してください", "The information filled in does not meet the requirements.  Please confirm the requirements and modify the information"], // 请输入分类名称



      ["deleteCategoryTitle", "温馨提示", "溫馨提示", "ご注意", "Notice"], // 删除分类
      ["delCategory1", "是否确定删除该分类?", "是否確定刪除該分類?", "このカテゴリ削除しますがよろしいでしょうか?", "Are you sure to delete this category?"],
      ["delCategory3", "是否确定删除该分类?仍有商品持有该分类，若该分类被删除，其下所有商品将失去相关分类标签。", "是否確定刪除該分類?仍有商品持有該分類，若該分類被刪除，其下所有商品將失去相關分類標籤。", "このカテゴリ削除しますがよろしいでしょうか?このカテゴリを持っている商品がまだ存在します。このカテゴリを削除する場合、該当商品がこのカテゴリラベルを失います。", "Are you sure to delete this category? There are items that belong to this category. If you delete this category, the category information of the item will be empty. "],
      ["delCategory2", "是否确定删除该分类?仍有子分类隶属于该分类，若该分类被删除，其下所有子分类也将被删除且其下所有商品将失去相关分类标签。", "是否確定刪除該分類?仍有子分類隸屬於該分類，若該分類被刪除，其下所有子分類也將被刪除且其下所有商品將失去相關分類標籤。", "このカテゴリ削除しますがよろしいでしょうか?このカテゴリに所属するカテゴリが存在します。このカテゴリを削除する場合、子階層のカテゴリも全て削除され、該当商品がこのカテゴリラベルを失います。", "Are you sure to delete this category? There are secondary categories that belong to this category. If you delete this category, all the secondary categories will also be deleted, and the category information of the item will be empty. "],
      ["delCategory4", "是否确定删除该分类?仍有子分类隶属于该分类，若该分类被删除，其下所有子分类也将被删除且其下所有商品将失去相关分类标签。", "是否確定刪除該分類?仍有子分類隸屬於該分類，若該分類被刪除，其下所有子分類也將被刪除且其下所有商品將失去相關分類標籤。", "このカテゴリ削除しますがよろしいでしょうか?このカテゴリに所属するカテゴリが存在します。このカテゴリを削除する場合、子階層のカテゴリも全て削除され、該当商品がこのカテゴリラベルを失います。", "Are you sure to delete this category? There are secondary categories that belong to this category. If you delete this category, all the secondary categories will also be deleted, and the category information of the item will be empty. "], // 删除分类
      ["deletePush", "是否确定将该推送从展厅移除?", "是否確定將該推送從展廳移除?", "このおすすめをショールームから移出しますがよろしいでしょうか?", "Are you sure to remove this featured one from showroom?"],



      ["noPositionId", "请选择流通类型", "請選擇流通類型", "流通類型をお選びください", "Please select distribution type"]
    ],



   // 2022-11-16新增 下单设置
    "deliverySet": [
      ["add", "添加下单选项", "添加下單選項", "オーダーオプション追加", "Add Order Option"],
      ["edit", "编辑下单选项", "編輯下單選項", "オーダーオプション編輯", "Edit Order Option"],
      ["del", "是否确定删除该下单选项?", "是否確定刪除該下單選項?", "このオーダーオプション削除しますがよろしいでしょうか?", "Are you sure to delete this  配送der option ?"],
      ["children", "下位选项", "下位選項", "下位オプション", "Sub Option"],
      ["title", "选项名称", "選項名稱", "オプション名称", "Option Name"],



      ["arrived", "确认送达", "确认送达", "确认送达", "确认送达"],
      ["cancel", "取消订单", "取消订单", "取消订单", "取消订单"],
    ],




    "storePage": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["formTimeS", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeE", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeC", "~", "~", "~", "~"],
      ["formStoreName", "店铺", "店鋪", "ストア", "Store"],
      ["formStoreNamePlaceholder", "店铺的ID、编号、名称", "店鋪的ID、編號、名稱", "ストアのID、番号、名称", "ID, No., name of store"],
      ["formStatus", "状态", "狀態", "状態", "Status"],
      ["formStatusPlaceholder", "全部", "全部", "全て", "All"],
      ["add", "去开店 ! ", "去開店 ! ", "新規開店 ! ", "Open a New Store ! "],
      ["add2", "去开店 ! ", "去開店 ! ", "新規開店 ! ", "Open a New Store ! "],
    ],



    "storeEdit": [
      ["edit0", "编辑店铺基本信息", "編輯店鋪基本信息", "ストア基本情報編輯", "Edit Store Basic Info."],
      ["edit1", "编辑店铺营业时间", "編輯店鋪營業時間", "営業時間編輯", "Edit Business Hours"],
      ["edit2", "编辑交易等信息", "編輯交易等信息", "特商法表記編輯", "Edit Basic Info. etc. "],
      ["step1", "表述", "表述", "表記", "Notation"],
      ["step2", "营业时间", "營業時間", "営業時間", "Business Hours"],
      ["step3", "交易等信息", "交易等信息", "特商法表記", "Basic Info. etc. "],
      ["btn1", "保存", "保存", "一時保存", "Save"],
      ["btn2", "下一步", "下一步", "次へ", "Next"],
      ["btn3", "上一步", "上一步", "前へ", "Back"],
      ["submitText", "确认并提交", "確認並提交", "確認して提出", "Confirm and Submit"],

      // 表述	表述	表記	Notation
      ["title0", "表述", "表述", "表記", "Notation"],
      ["title1", "详细", "詳細", "詳細", "Detailed"],



      ["title2", "店铺设置", "店鋪設置", "ストア設定", "Store Setting"],
      ["form11_2", "店铺图标", "店鋪圖標", "ストアロゴ", "Store Logo"],
      ["form11", "店铺图标:", "店鋪圖標", "ストアロゴ", "Store Logo"],
      ["form12", "自动接单:", "自動接單", "自動注文確認", "Automatically Confirming"], // 用户下单后是否自动确认订单
      ["form12-1", "自动接单(B/C)", "自動接單(B/C)", "自動注文確認(B/C)", "Auto Confirming(B/C)"], // 是否自动确认订单
      ["form12_yes", "是", "是", "はい", "Yes"],
      ["form12_no", "否", "否", "いいえ", "No"],





      ["form1", "编号", "編號", "番号", "No"],
      // 店名	店名	店舗名	Store Name
      ["form2", "店铺名称:", "店鋪名稱:", "店舗名:", "Store Name:"],
      ["form3", "紧急联络方式:", "緊急聯絡方式:", "緊急連絡先:", "Emergency Contact:"],
      ["form4", "负责人姓名:", "負責人姓名:", "担当者名前:", "Name (Person in Charge):"],
      ["form5", "负责人电话:", "負責人電話:", "担当者電話番号:", "Phone No. (Person in Charge):"],
      ["form6", "负责人邮箱:", "負責人電郵:", "担当者メール:", "E-mail (Person in Charge):"],
      ["form7", "地址:", "地址:", "住所:", "Address:"],
      ["form8", "主要业务内容:", "主要業務內容:", "主な業務内容:", "Business Contents:"],


      ["form13", "积分规则", "積分規則", "ポイントルール", "Points Rules"],
      ["form13Title", "每实付1円可获得店内积分:", "每實付1円可獲得店內積分:", "実際支払金額1円に付きストアポイント獲得数:", "Every Actually paid 1 円 earns store points:"],
      ["form13Title2", "Pt", "Pt", "Pt", "Pt"],
      ["form13Title3", "1 Pt 可抵", "1 Pt 可抵 ", "1 Pt は ", "1 Pt can be used as  "],
      ["form13Title3Sub", " 円 ", " 円 ", " 円 として利用できます", " 円 "],
      ["form13Noinput", "半角数字(0.00000~99.99999)", "半角數字(0.00000~99.99999)", "半角数字(0.00000~99.99999)", "half-width number(0.00000~99.99999)"],

      
      ["form14", "取货地址(A类)", "取貨地址(A類)", "集荷住所(Aタイプ)", "Pickup Address (A Type)"],
      ["form14Title", "地址", "地址", "住所", "Address"],
      ["form15", "取货地址(B类)", "取貨地址(B類)", "集荷住所(Bタイプ)", "Pickup Address (B Type)"],


      ["noAdd1", "邮政编码(半角数字, 例: 1608338)", "郵政編碼(半角數字, 例: 1608338)", "郵便番号(半角数字, 例: 1608338)", "Zip code (Half-width numbers,  E.g.: 1608338)"],
      ["noAdd2", "都道府県", "都道府県", "都道府県", "Prefectures"],
      ["noAdd3", "市区町村", "市区町村", "市区町村", "Municipalities"],
      ["noAdd4", "町名番地号等(例: 西新宿1-33-1)", "町名番地号等(例: 西新宿1-33-1)", "町名番地号等(例: 西新宿1-33-1)", "Chome address( E.g.: 西新宿1-33-1)"],
      ["noAdd5", "其他：如建筑名公司名房间号(选填、例: Mini Station 101) ", "其他：如建築名公司名房間號(選填、例: Mini Station 101)", "その他: 建物や社名部屋番号等(あれば、例:ミニステーション101)", "Others: building, room number, etc. (Option、 E.g.: Mini Station 101)"],
      ["noAdd6", "国家地区, 省份等(例: 日本国東京都)", "國家地區, 省份等(例: 日本国東京都)", "国か地域, 都道府県等(例: 日本国東京都)", "Country or Region, State, Province(E.g.: Japan Tokyo)"],
      ["noAdd7", "地方市区县乡街道等(例: 新宿区)", "地方市區縣鄉街道等(例: 新宿区)", "市区町村等(例: 新宿区)", "Municipalities, City (E.g.: Shinjyuku-ku)"],
      ["noAdd8", "路名小区门牌号等(例: 西新宿1-33-1)", "路名小區門牌號等(例: 西新宿1-33-1)", "町名番地号等(例: 西新宿1-33-1)", "Street, number, etc. (E.g.: Nishishinjyuku 1-33-1)"],



      ["form16", "定休日:", "定休日", "定休日", "Regular Holiday"],
      ["form17", "通常营业时间", "通常營業時間", "通常営業時間", "General Business Hours"],
      ["restWeek", "每周", "每周", "毎週", "Weekly"],
      ["restDay", "每年", "每年", "毎年", "Yearly"],
      ["startTime", "HH:MM", "HH:MM", "HH:MM", "HH:MM"],
      ["endTime", "HH:MM", "HH:MM", "HH:MM", "HH:MM"],
      ["payrestWeek", "每周", "每周", "毎週", "Weekly"],
      ["payrestYear", "每年", "每年", "毎年", "Yearly"],
      ["payrest", "定休日", "定休日", "定休日", "Regular Holiday"],


      ["form18", "退货退款与售后服务细则:", "退貨退款與售後服務細則:", "返品・返金・アフターサービス等の詳細ポリシー:", "Details of Returns, Refunds, After-sale-service etc. :"],
      ["form19", "其他店铺政策:", "其他店鋪政策:", "その他店舗ポリシー:", "Other Store Policy:"],
      ["form20", "补充事项:", "補充事項:", "補足事項:", "Supplementary Matter:"], // 店铺政策
      ["form21", "联系方式:", "聯系方式:", "連絡先:", "Contact Information:"],
      ["form22", "销售价格:", "銷售價格:", "販売価格:", "Selling Price:"],
      ["form23", "商品售价以外的其他收费:", "商品售價以外的其他收費:", "商品代金以外の必要料金:", "Charges other than the price of the product:"],
      ["form24", "下单规则:", "下單規則:", "注文方法:", "Order rules:"], // 下单规则
      ["form25", "支付方法・支付时期・支付期限:", "支付方法・支付時期・支付期限:", "支払方法・支払時期・支払期限:", "Payment Method ・Payment Period ・  Time Limit of the Payment:"], // 支付期限
      ["form26", "商品的交付:", "商品的交付:", "商品の引渡:", "Delivery of Items:"],
      ["form27", "售后:", "售後:", "アフターサービス:", "After Service:"],
      ["form28", "营业时间", "營業時間", "営業時間", "Business Hours"],
      ["mainName", "贩卖者:", "販賣者:", "販売業者:", "Seller:"], // 店铺运营者名称
      ["mainAdminName", "运营统括责任人:", "運營統括責任人:", "運営統括責任者:", "Operation Manager:"], // 店铺负责人名称
      ["mainAddress", "所在地:", "所在地:", "所在地:", "Store Location:"], // 店铺地址



      ["stopStore", "是否确定临时休业?", "是否確定臨時休業?", "臨時休業しますがよろしいでしょうか?", "Are you sure to going to be temporarily closed?"],
      ["temporaryOpen", "是否确定临时开业?", "是否確定臨時開業?", "臨時開業しますがよろしいでしょうか?", "Are you sure to going to be temporarily opening?"],
      ["fixStore", "是否确定恢复营业?", "是否確定恢復營業?", "営業を再開しますがよろしいでしょうか?", "Are you sure to back to opening store?"],
      ["reClose", "是否确定恢复休业?", "是否確定恢復休業?", "休業に戻りますがよろしいでしょうか?", "Are you sure to back to closing store?"],

      ["withdraw", "是否确定申请关店?注销后将无法再使用此店铺。", "是否確定申請關店?註銷後將無法再使用此店鋪。?", "閉店を申請しますがよろしいでしょうか?廃業後このストアを使えなくなります。", "Are you sure to apply for shutting down this store?You will no longer be able to use this store after shutting down, "],
      ["remove", "是否确定删除该店铺?店铺删除后不可恢复。", "是否確定刪除該店鋪?店鋪刪除後不可恢復。", "ストアを削除しますがよろしいでしょうか?削除したストアは復元できません。", "Are you sure to delete this store?Deleted stores cannot be restored."],

      ["back", "是否确定撤销该申请?", "是否確定撤銷該申請?", "この申請を撤回しますがよろしいでしょうか?", "Are you sure to withdraw this application?"],
      ["backEdit", "是否确定撤销编辑中的内容?", "是否確定撤銷編輯中的內容?", "編輯中の内容を取り消しますがよろしいでしょうか?", "Are you sure to undo the content being edited??"],

    ],



    "store": [
      ["createTime", "时间", "時間", "時間", "Time"],
      ["id", "ID", "ID", "ID", "ID"],
      ["managementNumber", "编号", "編號", "番号", "No"],
      ["number", "编号", "編號", "番号", "No."],
      ["title", "名称", "名稱", "名称", "Name"],
      ["phone", "紧急联络方式", "緊急聯絡方式", "緊急連絡先", "Emergency Contact"],
      ["adminName", "负责人姓名", "負責人姓名", "担当者名前", "Name (Person in Charge)"],
      ["adminPhone", "负责人电话", "負責人電話", "担当者電話番号", "Phone No. (Person in Charge):"],
      ["adminEmail", "负责人邮箱", "負責人電郵", "担当者メール", "E-mail (Person in Charge)"],
      ["address", "联系地址", "聯繫地址", "連絡先住所", "Contact Address"],
      ["des", "主要业务内容", "主要業務内容", "主な業務内容", "Main Business Content"],


      ["status1", "正常-营业中", "正常-營業中", "正常-営業中", "Normal - Open"],
      ["status2", "正常-准备中", "正常-準備中", "正常-準備中", "Normal – Close"],
      ["status3", "正常-临时休业中", "正常-臨時休業中", "正常-臨時休業中", "Normal - Temporary Close"],
      ["status20", "正常-临时开业中", "正常-臨時開業中", "正常-臨時開業中", "Normal – Temporary Open"],
      ["status4", "编辑中-新店开业", "編輯中-新店開業", "編輯中-新規開業", "Editing – for Opening"],
      ["status5", "编辑中-营业中", "編輯中-營業中", "編輯中-営業中", "Editing – Open"],
      ["status6", "编辑中-准备中", "編輯中-準備中", "編輯中-準備中", "Editing – Close"],
      ["status7", "编辑中-临时休业中", "編輯中-臨時休業中", "編輯中-臨時休業中", "Editing – Temporary Close"],
      ["status23", "编辑中-临时开业中", "編輯中-臨時開業中", "編輯中-臨時開業中", "Editing – Temporary Open"],
      // ["status0", "审核中-新店开业", "審核中-新店開業", "審査中-新規開業", "Reviewing - for Opening"], // 弃，改status8
      ["status8", "审核中-新店开业", "審核中-新店開業", "審査中-新規開業", "Reviewing - for Opening"],
      ["status9", "审核中-营业中", "審核中-營業中", "審査中-営業中", "Reviewing - Open"],
      ["status10", "审核中-准备中", "審核中-準備中", "審査中-準備中", "Reviewing- Close"],
      ["status11", "审核中-临时休业中", "審核中-臨時休業中", "審査中-臨時休業中", "Reviewing - Temporary Close"],
      ["status21", "审核中-临时开业中", "審核中-臨時開業中", "審査中-臨時開業中", "Reviewing - Temporary Open"],
      ["status12", "已驳回-新店开业", "已駁回-新店開業", "却下済-新規開店", "Rejected- for Opening"],
      ["status13", "已驳回-营业中", "已駁回-營業中", "却下済-営業中", "Rejected - Open"],
      ["status14", "已驳回-准备中", "已駁回-準備中", "却下済-準備中", "Rejected- Close"],
      ["status15", "已驳回-临时休业中", "已駁回-臨時休業中", "却下済-臨時休業中", "Rejected- Temporary Close"],
      ["status22", "已驳回-临时开业中", "已駁回-臨時開業中", "却下済-臨時開業中", "Rejected- Temporary Open"],
      ["status27", "已驳回-审核中", "已駁回-審核中", "却下済-審査中", "Rejected- Reviewing"],
      ["status16", "注销中", "註銷中", "廃業中", "Shuttering"],
      ["status17", "已注销", "已註銷", "廃業済", "Shut Down"],
      ["status18", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["status19", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["status24", "冻结中-审核中", "凍結中-審核中", "ロック中-審査中", "Blocked- Reviewing"],
      ["status25", "冻结中-审核中", "凍結中-審核中", "ロック中-審査中", "Blocked- Reviewing"],
      ["status26", "冻结中-已驳回", "凍結中-已駁回", "ロック中-却下済", "Blocked- Rejected"],
      ["status28", "解冻已驳回", "解凍已駁回", "ロック解除却下済", "Unblocking Rejected"],
      ["status29", "冻结中-注销中", "凍結中-註銷中", "ロック中-廃業中", "Blocked- Shuttering"],

    ],





    "storeRule": [
      ["title", "请输入", "請輸入", "ご入力ください", "Please enter"],

    ],




    "storeDetail": [
      ["topTitle", "店铺详情", "店鋪詳情", "ストア/ストア詳細", "Store Details"],
      ["menu1", "基本", "基本", "基本", "Basic"],
      ["menu2", "营业时间", "營業時間", "営業時間", "Business Hours"],
      ["menu3", "交易等信息", "交易等信息", "特商法表記", "Basic Info. etc. "], // 店铺交易信息
      ["menu4", "收费", "收費", "料金", "Charges"],
      ["menu5", "记录", "記錄", "記録", "Record"], // 审核记录
      ["title1", "补充", "補充", "別添", "Attachment"],
      ["other_title", "其他", "其他", "その他", "Others"],
      ["status", "状态", "状態", "状態", "Status"],
      ["editSuccess", "撤销编辑", "撤銷編輯", "編輯撤回", "Revoke Editing"],
      ["sure", "撤销申请", "撤銷申請", "申請撤回", "Revoke Request"], // 确认
      ["close", "申请注销店铺", "申請註銷店鋪", "廃業申請", "Apply for Shutter"],
      ["delete", "删除", "刪除", "削除", "Delete"],
      ["btn1", "临时休业", "臨時休業", "臨時休業", "Temporary Close"],
      ["btn2", "恢复营业", "恢復營業", "営業再開", "Reopen"],
      ["btn3", "撤销申请", "撤銷申請", "申請撤回", "Revoke Request"],
      ["btn4", "撤销申请", "撤銷申請", "申請撤回", "Revoke Request"], // 撤回关店申请
      ["btn5", "临时开业", "臨時開業", "臨時開業", "Temporary Open"],
      ["btn6", "恢复休业", "恢復休業", "再休業", "Reclose"],

      ["monthSumMoney", "合计计店铺赁费(円)", "合計店鋪賃費(円)", "合計ストア賃料(円)", "Total Store Rent Fee (円)"], // 月总费
      ["monthMoney", "基础店铺赁费(円)", "基礎店鋪賃費(円)", "基本ストア賃料(円)", "Basic  Store Rent Fee (円)"], // 基础费
      ["plusMoney", "追加店铺赁费(円)", "追加店鋪賃費(円)", "追加ストア賃料(円)", "Additional Store Rent Fee (円)"], // 加收费
      ["closeText", "是否确定申请关店?注销后将无法再使用此店铺。", "是否確定申請關店?註銷後將無法再使用此店鋪。", "閉店を申請しますがよろしいでしょうか?廃業後このストアを使えなくなります。", "Are you sure to apply for shutting down this store?You will no longer be able to use this store after shutting down, "],
      ["chooseMonth", "月", "月", "月", "Month"],
      ["serviceFeeRate", "销售服务费费率", "銷售服務費費率", "販売手数料料率", "Rate of Sales Commission"],
      ["storageUse", "内存使用情况", "內存使用情況", "ストレージ使用状況", "Storage Usage"],
      ["feeInfo", "店铺赁费", "店鋪賃費", "ストア賃料", "Store Rent Fee"],
      ["noteInfo", "收费说明", "收費說明", "料金説明", "Charge Explanation"],


      ["storageForm1", "峰值最大可用", "峰值最大可用", "最大時使用可量", "Peak Max Available"],
      ["storageForm2", "峰值已使用量", "峰值已使用量", "最大時使用済量", "Peak Usage"],
      ["storageForm3", "现在剩余量", "現在剩余量", "現在使用可残量", "Current Remaining"],
      ["storageForm4", "使用超额量", "使用超額量", "使用超過量", "Used Overage"],

      ["rate_1", "A类", "A類", "A類", "Type A"],
      ["rate_2", "B类", "B類", "B類", "Type B"],
      ["rate_3", "C类(现金)", "C类(現金)", "C类(現金)", "Type C (Cash)"],
      ["rate_4", "C类(现金以外)", "C类(現金以外)", "C类(現金以外)", "Type C (Other than cash)"],

      ["overUse1", "超额用量部分将按", "超額用量部分將按", "ストレージの無料利用限度を超えた場合、使用超過量に対して、", "If you exceed the free storage limit, you will be charged an additional store rent fee of "],// 流量超出文字前部分
      ["overUse2", "円/G的价格收取追加店铺赁费。不足1G的按1G计算。", "円/G的價格收取追加店鋪賃費。不足1G的按1G計算。", "円/G の追加ストア賃料がかかります。また、1G未満の場合は1Gと見なして計算します。", "円/G for overage. If it is less than 1G, it will be regarded as 1G and calculated."],// 流量超出说明
    ],



    "goodsIndex": [
      ["add", "添加商品", "添加商品", "アイテム追加", "Create Item"],
      ["edit", "编辑商品", "編輯商品", "商品編輯", "Edit Item"],
      ["upup", "批量上架", "批量上架", "まとめて販売開始", "Continue in bulk"],
      ["down", "批量下架", "批量下架", "まとめて販売停止", "Discontinue in bulk"],
      ["up", "批量删除", "批量刪除", "まとめて削除", "Delete in bulk"],
      ["formTitle", "商品", "商品", "アイテム", "Item"], // 商品名称
      ["formTitlePlaceholder2", "商品或 SKU的ID、编号、名称", "商品或 SKU的ID、編號、名称", "商品かSKUのID、番号、名称", "ID, No., Name of Items or SKU"],
      ["formType", "流通类型", "流通類型", "流通類型", "Distribution Type"], // 物流属性
      ["formCategory", "店铺分类", "店鋪分類", "ストアカテゴリ", "Store Category"], // 商家分类
      ["formTypePlaceholder", "全部", "全部", "全て", "All"], // 全部属性
      ["formAllPlaceholder", "全部", "全部", "全て", "All"],
      ["formNoCateTypePlaceholder", "全部", "全部", "全て", "All"],


      // ["status0", "审核中-上架中", "審核中-上架中", "審査中-販売中", "Reviewing - Available"],
      ["status1", "审核中-上架中", "審核中-上架中", "審査中-販売中", "Reviewing - Available"], //待审核-已上架
      ["status2", "审核中-下架中", "審核中-下架中", "審査中-撤去中", "Reviewing - Unavailable"],
      ["status3", "编辑中-新品", "編輯中-新品", "編輯中-新品", "Editing - New"],
      ["status4", "编辑中-上架中", "編輯中-上架中", "編輯中-販売中", "Editing - Available"],
      ["status5", "编辑中-下架中", "編輯中-下架中", "編輯中-撤去中", "Editing - Unavailable"],
      ["status6", "已驳回-上架中", "已駁回-上架中", "却下済-販売中", "Rejected - Available"],
      ["status7", "已驳回-下架中", "已駁回-下架中", "却下済-撤去中", "Rejected - Unavailable"],
      ["status8", "正常-上架中", "正常-上架中", "正常-販売中", "Normal - Available"],
      ["status9", "正常-下架中", "正常-下架中", "正常-撤去中", "Normal - Unavailable"],
      ["status10", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["status11", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["status12", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["status13", "冻结中-审核中", "凍結中-審核中", "ロック中-審査中", "Blocked- Reviewing"],
      ["status14", "冻结中-审核中", "凍結中-審核中", "ロック中-審査中", "Blocked- Reviewing"],



      ["batchDown", "是否确定将该当商品下架？", "是否確定將該當商品下架？", "該当商品の販売を停止しますが、よろしいでしょうか？", "Are you sure to stop selling the items?"],
      ["batchDel", "是否确定删除该当商品？", "是否確定刪除該當商品？", "該当商品を削除しますが、よろしいでしょうか？", "Are you sure to delete the items?"],
      ["batchUp", "是否确定将该当商品上架？", "是否確定將該當商品上架？", "該当商品の販売を開始しますが、よろしいでしょうか？", "Are you sure to start selling the items?"],
      ["AType", "该当商品因仍有库存未清理或仍有订单未完成，现在无法被删除。", "該當商品因仍有庫存未清理或仍有訂單未完成，現在無法被刪除。", "該当商品はまだ在庫が残っているまたは未完成注文が存在するため、現在削除することができません。", "The items cannot be deleted now because there is still inventory that has not been cleared or orders that have not been completed."],
      ["noCheckIds", "请选择要处理的商品", "請選擇要處理的商品", "商品をお選びください", "Please select items for processing"]

    ],



    "goodsEdit": [
      ["step1", "基本", "基本", "基本", "Basic"], // 商品基本信息
      ["step2", "展示", "展示", "展示", "Display"], // 展示信息
      ["step3", "库存", "庫存", "在庫", "Inventory"], // 库存
      ["btn1", "保存", "保存", "一時保存", "Save"], // 保存为编辑中
      ["btn2", "下一步", "下一步", "次へ", "Next"],
      ["btn3", "上一步", "上一步", "前へ", "Previous"],
      ["btn4", "提交", "提交", "提出", "Submit"], // 提交商品信息

      ["param", "属性", "屬性", "属性", "Attributes"],

      ["title1", "规格", "規格", "バリエーション", "Variation"], // 商品规格设置
      ["title2", "图像", "圖像", "画像", "Picture"], // 商品展示
      ["title3", "回廊", "迴廊", "ギャラリー", "Gallery"], // 商品详情
      ["title4", "产品参数", "產品參數", "インフォーメーション", "Information"], // 商品参数设置
      ["title5", "标签", "標籤", "ラベル", "Label"], // 标签设置

      ["form1", "商品编号:", "商品編號", "アイテム番号", "Item No."],
      ["form2", "商品名称:", "商品名稱:", "アイテム名称:", "Item Name:"],
      ["form3", "入口:", "入口:", "入口:", "Entrance:"], // 商品物流属性
      ["form4", "处理类型:", "處理類型:", "取扱類型:", "Shipping Type:"],
      ["form5", "保价金额(円/件):", "保價金額(円/件):", "保障金額(円/件):", "Insured Value (円/P):"],
      ["form6", "基本售价(円/件):", "基本售價(円/件):", "基本販売価格(円/件):", "Basic Price (円/P):"], // 商品原价
      ["form7", "实际售价(円/件):", "實際售價(円/件):", "実質販売価格(円/件):", "Actual Price (円/P):"],
      ["form8", "Milala分类", "Milala分類", "Milalaカテゴリ", "Milala Category"], // 平台分类标签
      ["form9", "店铺分类", "店鋪分類", "ストアカテゴリ", "Store Category"], // 店铺分类标签
      ["form10", "品牌", "品牌", "ブランド", "Brand"], // 品牌标签
      ["form11", "市场", "市場", "マーケット", "Market"], // 市场标签
      ["form12", "消费税率", "消費稅率", "消費税率", "VAT Rate"], // 23年4月17日新更新 消费税率

			["spe_name", "规格组名", "規格組名", "グループ名", "Group Name"], // 规格名称
			["spe_param", "规格参数", "規格參數", "バリエーション", "Variation"], // 规格参数
      ["spe_name2", "规格组名(如颜色，尺寸等)", "規格組名(如顏色，尺寸等)", "グループ名(色、サイズなど)", "Group Name (color, size, etc.)"],
      ["spe_detail", "规格选项", "規格選項", "バリエーション展開", "Variation Options"],
      ["spe_fun", "操作", "操作", "操作", "Operation"],
      ["sku", "编号", "編號", "番号", "No."], // SKU编号
      ["premium", "溢价调整(円/件)", "溢價調整(円/件)", "価格増減(円/件)", "Price Difference(円/件)"],
      ["goodsLong", "长(cm)", "長(cm)", "長さ(cm)", "Length(cm)"],
      ["wide", "宽(cm)", "寬(cm)", "広さ(cm)", "Width(cm)"],
      ["high", "高(cm)", "高(cm)", "高さ(cm)", "Height(cm)"],
      ["weight", "重(g)", "重(g)", "重さ(g)", "Weight(g)"],
      ["stock", "总库存", "總庫存", "合計在庫", "Total Stock"],
      ["stockNum", "库存数", "庫存數", "在庫数", "Inventory"], // 库存数
      ["brandTips", "通过审核后才会展示", "通過審核後才會展示", "表示するには審査が必要", "It will not be displayed until it has been approved"],
      // （设置了商品市场标签后，该商品需要审核通过后才能展示）
      ["marketTips", "通过审核后才会展示", "通過審核後才會展示", "表示するには審査が必要", "It will not be displayed until it has been approved"],
      ["mainLable", "主标签", "主標簽", "メインラベル", "Main Label"], // 主分类标签
      ["otherLable", "副标签", "副標籤", "サブラベル", "Sub Label"], // 其他标签



      ["maxVedio", "最多只能上传1个视频", "最多只能上傳一個視頻", "ビデオは最大1個までアップロード可能", "At most 1 video can be uploaded"],
      ["img1ToImg", "正面图只能为图片", "正面圖只能為圖片", "正面図は図のみアップロード可能", "Front photo can only be a picture"],
      ["maxImg", "最多只能上传6个图像", "最多只能上傳6個圖像", "画像は最大6個までアップロード可能", "At most 6 pictures can be uploaded"],
      ["minImg", "至少要上传2个图像", "至少要上傳2個圖像", "画像は少なくとも2個アップロード必要", "At least 2 pictures must be uploaded"],



    ],
    "goodsRule": [
      ["name", " ", " ", " ", " "],
      ["maxName", " ", " ", " ", " "],
      ["type", " ", " ", " ", " "],
      ["priceShow", " ", " ", " ", " "],
      ["priceShowMin", " ", " ", " ", " "],
      ["key", " ", " ", " ", " "],
      ["admin_mobile", " ", " ", " ", " "],
      ["admin_email", " ", " ", " ", " "],
      ["districtcode", " ", " ", " ", " "],
      ["province", " ", " ", " ", " "],
      ["city", " ", " ", " ", " "],
      ["area", " ", " ", " ", " "],
      ["addres", " ", " ", " ", " "],
      ["adminCode", " ", " ", " ", " "],
      ["email", " ", " ", " ", " "],
      ["password", " ", " ", " ", " "],
      ["emailCode", " ", " ", " ", " "],
      ["rePassword", " ", " ", " ", " "],
      ["noSpeList", " ", " ", " ", " "],
      ["noSpeName", " ", " ", " ", " "],
      ["noSpeDetail", " ", " ", " ", " "],
      ["noSonLong", " ", " ", " ", " "],
      ["noSonWide", " ", " ", " ", " "],
      ["noSonHigh", " ", " ", " ", " "],
      ["noSonWeight", " ", " ", " ", " "],
      ["noStock", " ", " ", " ", " "],
      ["address", " ", " ", " ", " "],
      ["remark", " ", " ", " ", " "],
      ["des", " ", " ", " ", " "],
      ["speName", " ", " ", " ", " "],


      ["maxWeight", "重量上限", "重量上限", "重さ上限", "Max Weight"],
      ["maxLong", "长度上限", "長度上限", "長さ上限", "Max Length"],
      ["maxWide", "宽度上限", "寬度上限", "広さ上限", "Max Width"],
      ["maxHigh", "高度上限", "高度上限", "高さ上限", "Max Height"],


      ["speDetails", "请输入(30字节内)", "請輸入(30字節內)", "ご入力ください(30バイト内)", "Please enter (within 30 bytes)"],
      ["speDetailsHolder", "请输入(30字节内)", "請輸入(30字節內)", "ご入力ください(30バイト内)", "Please enter (within 30 bytes)"],
      ["placeholderStock", "半角整数(0~99999999)", "半角整數(0~99999999)", "半角整数(0~99999999)", "Integer (0~99999999)"],
      ["premium", "-9999999~9999999", "-9999999~9999999", "-9999999~9999999", "-9999999~9999999"],
      ["sku", "15字节内", "15字節內", "15バイト内", "within 15 bytes"],
      ["entrance", "请选择入口", "請選擇入口", "入口をお選びください", "Please select entrance"],
      ["keyword", "关键词间用半角逗号隔开(共256字节内，单个32字节内)", "關鍵詞間用半角逗號隔開(共256字節內，單個32字節內)", "半角コンマで区切ってください(合計256バイト内，1個32バイト内)", "Separate the keywords with commas (within 256 bytes totally，32 bytes for each)  "],

      ["entrance_1", "店铺还没有入口，请先去添加入口", "店鋪還沒有入口，請先去添加入口", "ストアの入口がまだできていませんので、先に入口を追加してください", "The store has no entrance yet.  Please add an entrance first"],
    ],



    "goods": [
      ["positive", "图像", "圖像", "画像", "Picture"], // 商品正面图
      ["createTime", "时间", "時間", "時間", "Time"], // 创建时间
      ["updateTime", "更新时间", "更新時間", "更新時間", "Update Time"], // 最近修改日期
      ["goodsSn", "编号", "編號", "番号", "No."], // goodsSn
      ["goodsSn2", "编号", "編號", "番号", "No."], // 管理编号
      ["goodsName", "名称", "名稱", "名称", "Name"], // 商品名称
      ["goodsName2", "商品名称", "商品名稱", "アイテム名称", "Item Name"], // 商品名称

      // ["num", "库存数量", "庫存數量", "在庫数量", "Stock Number"], // 在库数量
      ["num2", "总库存", "總庫存", "合計在庫", "Total Stock"], // 库存总量
      ["num3", "数量", "數量", "数量", "Number"],
      ["type", "入口", "入口", "入口", "Entrance"],
      ["type2", "入口", "入口", "入口", "Entrance"], // 物流属性
      ["type1", "处理类型", "處理類型", "取扱類型", "Shipping Type"], // 处理类型


      ["id", "ID", "ID", "ID", "ID"],
      ["id1", "商品 ID", "商品 ID", "アイテムID", "Item ID"],
      ["merchantStoreId", "所属 ID", "所屬 ID", "所属 ID", "Belonging ID"],
      ["priceOffer", "保价金额(円/件)", "保價金額(円/件)", "保障金額(円/件)", "Insured Value(円/P)"],
      ["price", "基本售价(円/件)", "基本售價(円/件)", "基本販売価格(円/件)", "Basic Price(円/P)"], // 商品原价
      ["priceShow", "实际售价(円/件)", "實際售價(円/件)", "実質販売価格(円/件)", "Actual Price(円/P)"], // 商品售价
      ["salesServiceFee", "流通服务费(円/件)", "流通服務費(円/件)", "流通手数料(円/件)", "Distribution Fee(円/P)"], // 提成
      ["averagePremium","平均保费(円/件)","平均保費(円/件)","平均プレミアム費(円/件)","Aver. Prem. Fee(円/P)"],//保费
      ["logisticsServiceFee", "销售服务费(円/件)", "銷售服務費(円/件)", "販売手数料(円/件)", "Distribution Fee(円/P)"], // 流费
      ["profit", "预计收益(円/件)", "預計收益(円/件)", "概算収益(円/件)", "Estimated Revenue (円/P)"], // 收益
      ["sku", "编号", "編號", "番号", "No."], // SKU编号
      ["skuId", "ID", "ID", "ID", "ID"], // SKU ID
      ["skuId2", "SKU 编号", "SKU 編號", "SKU 番号", "SKU No."],
      ["skuId3", "SKU ID", "SKU ID", "SKU ID", "SKU ID"],
      ["skuName", "SKU名称", "SKU名稱", "SKU名稱", "SKU Name"],
      ["skuName2", "SKU 名称", "SKU 名稱", "SKU 名稱", "SKU Name"],
      ["preName", "参数名称", "參數名稱", "パラメータ名称", "Parameters Name"],
      ["preDes", "参数详情", "參數詳情", "パラメータ詳細", "Parameters Detail"],
      ["orderPirce", "单价(円)", "單價(円)", "単価(円)", "Unit(円)"],
      ["orderSumPirce", "小计(円) ", "小計(円)", "小計(円)", "Subtotal(円)"],
      ["saleAfterPirce", "最高退款(円/点)", "最高退款(円/點)", "返金上限(円/点)", "Maximum Refund(円/U)"],
      ["num", "数量", "數量", "数量", "Number"],
      ["status", "状态", "狀態", "状態", "Status"], // 商品状态
      ["priceOffer2", "平均保价金额(円/点)", "平均保價金額(円/點)", "平均保障金額(円/点)", "Aver. Insured Value(円/P)"],
      ["premium", "保费(円/点)", "保費(円/點)", "プレミアム費(円/点)", "Premium Fee (円/P)"],
      ["keyword","关键词","關鍵詞","キーワード","Keyword"],
      ['consumeRateVal','税率','稅率','税率','Tax Rare']

    ],



    "goodsDetail": [
      ["topTitle", "商品详情", "商品詳情", "アイテム詳細", "Item Details"],
      ["down", "下架", "下架", "撤去", "Discontinue"],
      ["up", "上架", "上架", "発売", "Put on Sale"],
      ["btn1", "查看评价", "查看評價", "レビュー", "Review"],
      ["btn2", "商品统计", "商品統計", "商品データ", "Item Statistics"],
      ["btn3", "库存统计", "庫存統計", "在庫データ", "Inventory Statistics"],
      ["menu1", "基本", "基本", "基本", "Basic"], // 商品基本信息
      ["menu2", "展示", "展示", "展示", "Display"], // 商品展示信息
      ["menu3", "库存", "庫存", "在庫", "Inventory"], // 商品库存信息
      ["menu4", "记录", "記錄", "履歴", "History"], // 商品处理记录
      ["title0", "属性", "屬性", "属性", "Attributes"],
      ["title1", "规格", "規格", "バリエーション", "Variation"], // 商品规格
      ["title2", "SKU", "SKU", "SKU", "SKU"], // 规格详情
      ["title3", "图像", "圖像", "画像", "Picture"], // 商品展示
      ["title4", "回廊", "回廊", "ギャラリー", "Gallery"], // 商品详情
      ["title5", "产品参数", "產品參數", "インフォーメーション", "Information"],
      ["title6", "标签", "標籤", "ラベル", "Label"], // 标签信息
      ["title7", "关联商品", "關聯商品", "関連アイテム", "Related Item"],
      ["title8", "审核记录", "審核記錄", "審査記録", "Review Record"],
      ["title9", "冻结记录", "凍結記錄", "ロック記録", "Block Record"],
      ["title10", "解冻申请记录", "解凍申請記錄", "ロック解除申請記録", "Unblock Application Record"],
      ["label1", "MLL分类", "MLL分類", "MLLカテゴリ", "MLL Category"], //  平台分类标签
      ["label2", "店铺分类", "店鋪分類", "ストアカテゴリ", "Store Category"], // 店铺分类标签
      ["label3", "品牌", "品牌", "ブランド", "Brand"], // 商品品牌标签
      ["label4", "市场", "市場", "マーケット", "Market"], // 商品市场标签
      ["mainLable", "主标签", "主標簽", "メインラベル", "Main Label"],
      ["otherLable", "副标签", "副標籤", "サブラベル", "Sub Label"], // 其他标签
      ["noLabelId", "请选择", "請選擇", "お選びください", "Please select"], // 请选择一级分类
      ["noSonlabelId", "请先选择一级分类", "請先選擇一級分類", "まず1階カテゴリ選択", "Select a primary category first"],
      ["sure", "结束该案件", "結束該案件", "ケースを終了", "End the Case"], // 确认
      ["sure02", "撤销申请", "撤銷申請", "申請撤回", "Revoke Request"], // 确认
    ],





    "couponPage": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["formTimeS", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeE", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeC", "~", "~", "~", "~"],
      ["formName", "优惠券", "優惠券", "クーポン", "Coupon"],
      ["formNamePlaceholder", "优惠券的ID、编号、名称", "優惠券的ID、編號、名稱", "クーポンのID、番号、名称", "ID, No., name of coupon"],
      ["formStatus", "状态", "狀態", "状態", "Status"],
      ["formStatusPlaceholder", "全部", "全部", "全て", "All"],
      ["formStatus1", "发放中", "發放中", "配布中", "Issuing"],
      ["formStatus2", "停止发放中", "停止發放中", "配布停止中", "Unissuing"],
      ["formStatus3", "全部领完", "全部領完", "全て受取済", "All Issued"],
      ["formStatus4", "全部用完", "全部用完", "全て使用済", "All Used"],
      ["formStatus5", "已失效", "已失效", "失効済", "Expired"], // 原 已作废
      ["formIsCode", "验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["formIsCodePlaceholder", "全部", "全部", "全て", "All"],
      ["formIsCode1", "必要", "必要", "必要", "Necessary"],
      ["formIsCode2", "不要", "不要", "不要", "Unnecessary"],

      ["add", "添加优惠券", "添加優惠券", "クーポン追加", "Add Coupon"],

      ["couponCode", "编号", "編號", "番号", "No. "], // 优惠券编号
      ["couponName", "名称", "名稱", "名称", "Name"],
      ["useTime", "有效期间", "有效期間", "有効期間", "Validity Period"],
      ["conditionAmount", "门槛金额(円)", "門檻金額(円)", "条件金額(円)", "Consumption Condition (円)"],
      ["discountAmount", "折扣面额", "折扣面額", "割引額面", "Discount Amount"],
    ],

    "coupon": [
      ["couponCode", "编号", "編號", "番号", "No. "],
      ["isCode", "验证码", "驗證碼", "認証コード", "Verify. Code"], // 是否需要兑换码兑换
      ["couponName", "名称", "名稱", "名称", "Name"],
      ["type", "类型", "類型", "タイプ", "Type"],
      ["useTime", "有效期间", "有效期間", "有効期間", "Validity Period"],
      ["num", "总计数量", "總計數量", "合計数量", "Total Number"],

      ["conditionAmount", "门槛金额", "門檻金額", "条件金額", "Consumption Condition"],
      ["conditionAmount2", "门槛金额", "門檻金額", "条件金額", "Consumption Condition"],
      ["discountAmount", "折扣面额", "折扣面額", "割引額面", "Discount Amount"],
      ["discountRatio", "折扣面额", "折扣面額", "割引額面", "Discount Amount"],
      ["createTime", "时间", "時間", "時間", "Time"],
      ["id", "ID", "ID", "ID", "ID"],
      // ["merchantStore", "所属ID", "所屬ID", "所属ID", "Belonging ID"], // 所属店铺
      ["merchantStore","所属","所屬","所属","Belonging"],
      ["status", "状态", "狀態", "状態", "Status"],
      ["drawNum", "已领数量", "已領數量", "受取済数", "Received Number"],
      ["useNum", "已用数量", "已用數量", "使用済数", "Used Number"],


      ["detailNum", "总计数量", "總計數量", "合計数量", "Total Number"],
      ["detailConditionAmount", "门槛金额(円)", "門檻金額(円)", "条件金額(円)", "Consumption Condition (円)"],
      ["detailDiscountAmount", "折扣面额", "折扣面額", "割引額面", "Discount Amount"],

      ["ruleCouponCode", " ", " ", " ", " "],
      ["ruleIsCode", " ", " ", " ", " "],
      ["ruleCouponName", " ", " ", " ", " "],
      ["ruleType", " ", " ", " ", " "],
      ["ruleUseTime", " ", " ", " ", " "],
      ["ruleNum", " ", " ", " ", " "],
      ["ruleConditionAmount", " ", " ", " ", " "],
      ["ruleConditionAmount2", " ", " ", " ", " "],
      ["ruleDiscountAmount", " ", " ", " ", " "],
      ["ruleDiscountRatio", " ", " ", " ", " "],

      ["type1", "满减", "滿減", "金額割引", "Amount Off"],
      ["type2", "满折", "滿折", "割合割引", "Percent Off"],

      ["minConditionAmount", " ", " ", " ", " "],
    ],
    "couponDetail": [
      ["topTitle", "优惠券详情", "優惠券詳情", "クーポン詳細", "Coupon Details"],
      ["title1", "优惠券详情", "優惠券詳情", "クーポン詳細", "Coupon Details"],
      ["title2", "单券信息", "單券信息", "個別券情報", "Coupon List"], // 优惠券列表
      ["btn1", "停止发放", "停止發放", "配布停止", "Stop Issuing"],
      ["btn2", "开始发放", "開始發放", "配布開始", "Start Issuing"], // 原 恢复发放
      ["btn3", "删除", "刪除", "削除", "Delete"],
      ["search3", "领取与使用", "領取與使用", "受領及使用", "Receiving and Using"],
      ["item0", "全部", "全部", "全て", "All"],
      ["item1", "未领取", "未領取", "未受取", "Not Received"],
      ["item2", "已领取未使用", "已領取未使用", "受領済で未使用", "Received but not Used"],
      ["item3", "已使用", "已使用", "使用済", "Used"],
      ["table1", "ID", "ID", "ID", "ID"],
      ["table2", "验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["table3", "领取用户", "領取用戶", "受取ユーザー", "Received User"],
      ["table4", "领取时间", "領取時間", "受取時間", "Received Time"],
      ["table5", "使用时间", "使用時間", "使用時間", "Used Time"],

      ["stopTitle", "是否确定停止发放该优惠券？", "是否確定停止發放該優惠券？", "このクーポンの配布を停止しますが、よろしいでしょうか？", "Are you sure to stop issuing this coupon?"],
      ["fixTitle", "是否确定开始发放该优惠券？  ", "是否確定開始發放該優惠券？", "このクーポンの配布を開始しますが、よろしいでしょうか？", "Are you sure to start issuing this coupon?"],
      ["delTitle", "是否确定删除该优惠券？", "是否確定刪除該優惠券？", "このクーポンを削除しますが、よろしいでしょうか？", "Are you sure to delete this coupon?"],
      ["noDelete", "该优惠券已有用户领取，当前无法删除。", "該優惠券已有用戶領取，當前無法刪除。", "このクーポンを受け取ったユーザーが存在するため、現在削除することができません。", "This coupon has already been received by the user and cannot be deleted at present."],
    ],





    "content": [
      ["menuTitle", "内容", "內容", "コンテンツ", "Contents"],
      ["formTime", "时间", "時間", "更新時間", "Time"], // 推送时间
      ["formTimeS", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeE", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["content", "内容", "內容", "コンテンツ", "Contents"],
      ["add", "添加内容", "添加內容", "コンテンツ追加", "Create Contents"],
      ["edit", "编辑内容", "編輯內容", "コンテンツ編輯", "Edit Contents"],
      ["id", "ID", "ID", "ID", "ID"],
      ["type", "类型", "類型", "タイプ", "Type"], // 推送类型
      ["formIdPlaceholder", "内容的ID、编号、关键词", "內容的ID、編號、關鍵詞", "コンテンツのID、番号、キーワード", "ID, No., keyword of contents"],
      ["formTypePlaceholder", "全部", "全部", "全て", "All"],
      ["formStatusPlaceholder", "全部", "全部", "全て", "All"],
      ["number", "编号", "編號", "番号", "No."], // 管理编号
      ["status0", "非展示中", "非展示中", "非展示中", "Unshown"],
      ["status1", "展示中", "展示中", "展示中", "Showing"],
      ["status2", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["status3", "冻结中", "凍結中", "ロック中", "Blocked"],
      ["delete", "批量删除", "批量刪除", "まとめて削除", "Delete in Bulk"],
      ["display", "批量展示", "批量展示", "まとめて表示", "Display in Bulk"],
      ["unDisplay", "批量非展示", "批量非展示", "まとめて非表示", "Undisplay in Bulk"],
      ["type2", "类型", "類型", "タイプ", "Type"],
      ["status", "状态", "狀態", "状態", "Status"],
      ["browseNum", "浏览量", "瀏覽量", "閲覧数", "Views"],
      ["deleteTips", "是否确定删除该内容？", "是否確定刪除該內容？", "このコンテンツを削除しますが、よろしいでしょうか？", "Are you sure to delete this Contents?"],
      ["showTips", "是否确定展示该内容？", "是否確定展示該內容？", "このコンテンツを表示しますが、よろしいでしょうか？", "Are you sure to display this Contents?"],
      ["hideTips", "是否确定非展示该内容？", "是否確定非展示該內容？", "このコンテンツを非表示にしますが、よろしいでしょうか？", "Are you sure to undisplay this Contents?"],


      ["noCheckIds", " ", " ", " ", " "],
      ["updateTime", "更新时间", "更新時間", "更新時間", "Update Time"],
    ],


    "contentEdit": [
      ["btn1", "提交", "提交", "提出", "Submit"],
      ["btn2", "添加+", "添加+", "追加+", "Add+"],
      ["step1", "属性", "屬性", "属性", "Attributes"],
      ["title1", "关联商品", "關聯商品", "関連アイテム", "Related Item"],

      ["form1", "编号", "編號", "番号", "No."], // 内容管理编号
      ["form2", "类型", "類型", "タイプ", "Type"],
      ["form3", "正文", "正文", "テキスト", "Text"],
      ["form4", "图像", "圖像", "画像", "Picture"],
      ["form5", "图像", "图像", "画像", "Picture"],

      ["type1", "图集", "圖集", "写真集", "Atlas"],
      ["type2", "视频", "視頻", "ビデオ", "video"],
      ["sureAdd", "确认并添加", "確認並添加", "確認して追加", "Confirm to add"],
      ["maxImage", "最多上传6个图片", "最多上傳6張圖片", "図は最大6個まで", "Upload up to 6 pictures"],
      ["maxVideo", "最多上传1个视频", "最多上傳1個視頻", "ビデオは最大1個まで", "Upload up to 1 video"],
      ["maxGoods", "最多关联12个商品", "最多關聯12個商品", "関連商品は最大12個まで", "Associate up to 12 items"],
      ["noImg", " ", " ", " ", " "],
      ["noVideo", " ", " ", " ", " "],
      ["onlyImage", " ", " ", " ", " "],
      ["onlyVideo", " ", " ", " ", " "],
      ["noContent", " ", " ", " ", " "],
    ],

    "contentRule": [
      ["type", " ", " ", " ", " "],
      ["noContent", " ", " ", " ", " "],
    ],

    "contentDetail": [
      ["topTitle", "内容详情", "內容詳情", "コンテンツ詳細", "Contents Details"],
      ["title1", "内容详情", "內容詳情", "コンテンツ詳細", "Contents Details"],
      ["menu1", "基本", "基本", "基本", "Basic"],
      ["menu2", "记录", "記錄", "履歴", "History"],
      ["img", "图像", "圖像", "画像", "Picture"],
      
      ["deleteTips", "是否确定删除该内容？", "是否確定刪除該內容？", "このコンテンツを削除しますが、よろしいでしょうか？", "Are you sure to delete this Contents?"],
      ["upTips", "是否确定展示该内容？", "是否確定展示該內容？", "このコンテンツを表示しますが、よろしいでしょうか？", "Are you sure to display this Contents?"],
      ["downTips", "是否确定非展示该内容？", "是否確定非展示該內容？", "このコンテンツを非表示にしますが、よろしいでしょうか？", "Are you sure to undisplay this Contents?"],

      ["up", "展示", "展示", "展示", "Show"],
      ["down", "非展示", "非展示", "非展示", "Unshow"],
    ],

    "contentAudit": [

    ],


    "sysMsgIndex": [

      ["form5", "图像", "图像", "画像", "Picture"],

      ["type1", "图集", "圖集", "写真集", "Atlas"],
      ["type2", "视频", "視頻", "ビデオ", "video"],
      ["maxImage", "最多上传6个图片", "最多上傳6張圖片", "図は最大6個まで", "Upload up to 6 pictures"],
      ["maxVideo", "最多上传1个视频", "最多上傳1個視頻", "ビデオは最大1個まで", "Upload up to 1 video"],
      ["onlyImage", " ", " ", " ", " "],
      ["onlyVideo", " ", " ", " ", " "],
      ["sureAdd", "确认并添加", "確認並添加", "確認して追加", "Confirm to add"],
    ],





    "orderPage": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["formTimeS", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeE", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeC", "~", "~", "~", "~"],
      ["formOrderNumber", "订单", "訂單", "注文", "Order"],
      ["formOrderNumberPlaceholder", "订单的ID、关键词", "訂單的ID、關鍵字", "注文のID、キーワード", "ID, keywords of order"],
      ["formUserId", "顾客", "顧客", "顧客", "Customer"],
      ["formUserIdPlaceholder", "顾客的ID、昵称", "顧客的ID、暱稱", "顧客のID、ニックネームを入力", "ID, nickname of customer"],
      ["formGoodsId", "SKU", "SKU", "SKU", "SKU"],
      ["formGoodsIdPlaceholder", "商品或SKU的ID、编号、名称", "商品或SKU的ID、編號、名稱", "アイテムかSKUのID、番号、名称", "ID, No., name of item or SKU"],



      ["nickname", "顾客", "顧客", "顧客", "Customer"],
      ["payAmount", "商品总额(円)", "商品總額(円)", "商品総額(円)", "Total Price (円)"],
      ["status", "状态", "狀態", "状態", "Status"],
      ["allRefund", " ", " ", " ", " "]
    ],

    "order": [
      ["status0", "待接单", "待接單", "確認待ち", "for Confirm"],
      ["status1", "待取货", "待取貨", "集荷待ち", "for Pick-up"],
      ["status2", "已拒绝", "已拒絕", "拒否済", "Rejected"],
      ["createTime", "时间", "時間", "時間", "Time"],
      ["id", "ID", "ID", "ID", "ID"],
      ["merchantStoreId","店铺ID", "店鋪ID", "ストアID", "Store ID"],
      ["merchantStoreId2","所属","所屬","所属","Belonging"],
      ["memberNickName", "顾客", "顧客", "顧客", "Customer"],
      ["status", "状态", "狀態", "狀態", "Status"],
      ['receiveName',"订单确认者"," 訂單確認者"," 注文確認者"," Order Confirmer"],
      ["pickUpB", "预计取货地址(B)", "預計取貨地址(B)", "集荷予定住所(B)", "Estimated Pickup Address (B)"],
      ["pickUpTimeShow", "预计取货时间(B)", "預計取貨時間(B)", "集荷予定時間(B)", "Estimated Pickup Time (B)"],
      ["goodsAmount", "商品总额(円)", "商品總額(円)", "商品総額(円)", "Total Price (円)"],
      ['trueAmount1',"商品总额","商品總額","商品総額","Total Price"],
      ['trueAmount2',"店内折扣","店內折扣"," 店内割引","In-store Discount"],
      ['storeDeduction',"店内折扣(円)","店內折扣(円)","店内割引(円)","In-store Discount (yen)"],
      ['storeDeduction1',"店铺积分抵扣","店鋪積分抵扣","店内ポイント割引","Store Points"],
      ['storeDeduction2',"店铺优惠券抵扣","店鋪優惠券抵扣"," 店内クーポン割引","Store Coupon"],
      ['trueAmount',"实际销售额(円)","實際銷售額(円)","実質売上額(円)","Actual Sales (円)"],
      ['incomeAmount1',"实际销售额","實際銷售額","実質売上額"," Actual Sales"],
      ['userPirce1',"实际销售额","實際銷售額","実質売上額"," Actual Sales"],
      ['platformPirce',"MLL 收费(円)","MLL 收費(円)","MLL 費用(円)","MLL  Cost(円)"],
      ['incomeAmount2',"MLL 收费","MLL 收費","MLL 費用","MLL  Cost"],
      ['platformPirce1',"流通服务费","流通服務費","流通手数料"," Distribution Fee"],
      ['platformPirce2',"销售服务费"," 銷售服務費"," 販売手数料"," Commission Fee"],
      ["incomeAmount", "店铺收益(円)", "店鋪收益(円)", "ストア利益(円)", "Store Revenue (円)"],
      ["userPirce", "买家实付额(円)", "買家實付額(円)", "顧客実質支払額(円)", "Customer Actual Payment(円)"],
      ['userPirce2',"MLL 补贴"," MLL 補貼"," MLL 支援分"," MLL  Subsidy"],

    ],






    "orderPrint": [
      ["id", "订单ID", "訂單ID", "注文ID", "Order ID"],
      ["btn1", "接单", "接單", "確認", "Confirm It"], // 确认订单
      ["btn2", "拒绝", "拒絕", "拒否", "Reject"], // 拒绝订单
      ["scoreDeductionAfter", "円", "円", "円", "円"],
      ["title1", "商品", "商品", "アイテム", "Item"],
      ["title2", "记录", "記錄", "記録", "Record"],
      ["title3", "订单", "訂單", "注文", "Order"],
      ["sureOrder", "是否确定接受该订单？", "是否確定接受該訂單？", "この注文を確認しますがよろしいでしょうか？", "Are you sure to confirm this order?"],
      ["cancelOrder", "是否确定拒绝该订单？", "是否確定拒絕該訂單？", "この注文を拒否しますがよろしいでしょうか？", "Are you sure to cancel this order?"],
      ["record1", "订单取消", "訂單取消", "注文取消", "Order Canceled"]
    ],



    "orderDetail": [
      ["topTitle", "订单详情", "注文詳情", "注文詳細", "Order Details"],
      ["btn1", "接单", "接單", "確認", "Confirm It"], // 确认订单
      ["btn2", "拒绝", "拒絕", "拒否", "Reject"], // 拒绝订单
      ["scoreDeductionAfter", "円", "円", "円", "円"],
      ["title1", "商品", "商品", "アイテム", "Item"],
      ["title2", "记录", "記錄", "記録", "Record"],
      ["title3", "订单", "訂單", "注文", "Order"],
      ["sureOrder", "是否确定接受该订单？", "是否確定接受該訂單？", "この注文を確認しますがよろしいでしょうか？", "Are you sure to confirm this order?"],
      ["cancelOrder", "是否确定拒绝该订单？", "是否確定拒絕該訂單？", "この注文を拒否しますがよろしいでしょうか？", "Are you sure to cancel this order?"],
      ["record1", "订单取消", "訂單取消", "注文取消", "Order Canceled"]
    ],

    "otherOrder": [
      ["status1", "待付款", "待付款", "支払待ち", "for Payment"],
      ["status2", "送达中", "送達中", "配達中", "Shipping"],
      ["status3", "已交付", "已交付", "納品済", "Shipped"],
      ["status4", "已完成", "已完成", "終了", "Completed"],
      ["status5", "已取消", "已取消", "取消済", "Cancelled"],
      ["status6", "待接单", "待接單", "確認待ち", "for Confirm."],
      ["status7", "待取货", "待取貨", "集荷待ち", "for Pick-up"],
    ],
    "cOrder": [
      ["status0", "待接单", "待接單", "確認待ち", "for Confirm"],
      ["status1", "待付款", "待付款", "支払待ち", "for Payment"],
      ["status2", "待取货", "待取貨", "集荷待ち", "for Pick-up"],
      ["status3", "已交付", "已交付", "納品済", "Shipped"],
      ["status4", "已完成", "已完成", "完了済", "Completed"],
      ["status5", "已取消", "已取消", "取消済", "Cancelled"],
    ],



    "saleAfterPage": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["formTimeC", "~", "~", "~", "~"],
      ["formOrderNumber", "售后", "售後", "返金", "Refund"],
      ["formOrderNumberPlaceholder", "售后申请的ID、关键词", "售後申請的ID、關鍵字", "返金申請のID、キーワード", "ID, keywords of refund"],
      ["formOldOrderNumber", "关联订单", "關聯訂單", "関連注文", "Related Order"],
      ["formOldOrderNumberPlaceholder", "原商城订单的ID、关键词", "原商城訂單的ID、關鍵字", "元モール注文のID、キーワード", "ID, keywords  of original order"],
      ["formUserId", "顾客", "顧客", "顧客", "Customer"],
      ["formUserIdPlaceholder", "顾客的ID、昵称", "顧客的ID、暱稱", "顧客のID、ニックネーム", "ID, nickname of customer"],
      ["formType", "类型", "類型", "タイプ", "Type"], 
      ["formTypePlaceholder", "全部", "全部", "全て", "All"],
    ],

    "saleAfter": [
      ["type1", "仅退款(无需退货)", "僅退款(無需退貨)", "返金のみ(返品せず)", "Refund Only (No Returns)"],
      ["type2", "退货退款", "退貨退款", "返品して返金", "Return and Refund"],
      ["status0", "待处理", "待處理", "対応待ち", "for Process"],
      ["status1", "受理中", "受理中", "受理中", "Processing"],
      ["status2", "已拒绝", "已拒絕", "拒否済", "Rejected"],
      ["status3", "协助中", "協助中", "協調中", "Assisting"],
      ["status4", "售后成功", "售後成功", "返金成功", "Succeed"],
      ["status5", "已取消", "已取消", "取消済", "Cancelled"],
      ["status6", "售后失败", "售後失敗", "返金失敗", "Failed"], // 售后失败
      ["createTime", "时间", "時間", "時間", "Time"],
      ["id", "ID", "ID", "ID", "ID"],
      ["orderId", "关联订单ID", "關聯訂單ID", "関連注文ID", "Related Order ID"],
      ["merchantStoreId", "店铺ID", "店鋪ID", "ストアID", "Store ID"],
      ["merchantStoreId2","所属","所屬","所属","Belonging"],
      ["memberNickName", "顾客", "顧客", "顧客", "Customer"],
      ["refundAmount", "退款金额(円)", "退款金額(円)", "返金金額(円)", "Refund Amount (円)"],
      ["reasonStr", "申请理由", "申請理由", "申請理由", "Request Reason"],
      ["afterSaleStatus0-1", "买家提交退款申请", "買家提交​​退款申請", "バイヤーは返金申請を提出しました", "The buyer has submited the refund request"],
      ["afterSaleStatus0-2", "买家提交退款申请", "買家提交​​退款申請", "バイヤーは返金申請を提出しました", "The buyer has submited the refund request"],
      ["afterSaleStatus1", "店铺已同意退款申请", "店家已同意退款申請", "ストはは返金申請を同意しました", "The store has agreed to the refund request"],
      ["afterSaleStatus4-2", "店铺已同意退款申请", "店家已同意退款申請", "ストはは返金申請を同意しました", "The store has agreed to the refund request"],
      ["afterSaleStatus2", "店铺已拒绝退款申请", "店家已拒絕退款申請", "ストアは返金申請を拒否しました", "The store has rejected the refund request"],
      ["afterSaleStatus3", "买家已申请Milala协助", "買家已申請Milala協助", "バイヤーはMilalaサポートを申請しました", "The buyer has applied for Milala assistance"],
      ["afterSaleStatus4-1", "Milala已同意退款申请", "Milala已同意退款申請", "Milalaが返金申請を承認しました", "Milala has agreed to the refund request"],
      ["afterSaleStatus6", "Milala已拒绝退款申请，售后失败", "Milala已拒絕退款申請，售後失敗", "Milalaは返金申請を拒否しましたので、返金申請が失敗になった", "Milala has rejected the refund request, and the refund failed"],
      ["afterSaleStatus4-3", "Milala已确认完成退款,售后成功", "Milala已確認完成退款", "Milala", "Milala has completed the refund request, and the refund successed"],
      ["afterSaleStatus5", "买家已取消退款申请", "買家已取消退款申請", "バイヤーが返金申請を取り消しました", "The buyer has canceled the refund request"],
    ],



    "saleAfterDetail": [
      ["topTitle", "售后详情", "售後詳情", "返金詳細", "Refund Details"],
      ["btn1", "关联订单", "關聯訂單", "関連注文", "Related Order"],
      ["btn2", "受理", "受理", "受理", "Approve"], // 同意退款 受理	受理	受理	Approve
      ["btn3", "拒绝", "拒絕", "拒否", "Reject"], // 拒绝退款 拒绝	拒絕	拒否	Reject
      ["title1", "商品", "商品", "商品", "Item"],
      ["return_title1", "详情说明", "詳情說明", "詳細説明", "Description"],
      // ["return_title2", "图片凭证等", "圖片憑證等", "写真説明等", "Photo Attached etc."],
      ["return_title2", "图", "圖", "図", "Photo"],
      ["agreen", "是否确定受理该售后申请？", "是否確定受理該售後申請？", "この返金申請を受理しますがよろしいでしょうか？", "Are you sure to accept this refund request?"],
      ["refuseRefund", "是否确定拒绝该售后申请？", "是否確定拒絕該售後申請？", "この返金申請を拒否しますがよろしいでしょうか？", "Are you sure to reject this refund request?"],
      ["title2", "记录", "记录", "記録", "Record"],
      ["title3", "售后", "售後", "返金", "Refund"],
      ["tableItem1", "顾客实付(円/点)", "顧客實付(円/點)", "顧客実払額(円/点)", "Actual Payment(円/U)"],// 顾客实付(円/点)
      ["tableItem2", "MLL 补贴-(円/点)", "MLL 補貼(円/點)", "MLL 支援分(円/点)", "MLL  Subsidy(円/U)"],// 平台补贴(円/点)
    ],





    "logisticsPage": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["formOrderNumber", "订单", "訂單", "注文", "Order"],
      ["formOldOrderNumber", " ", " ", " ", " "],
      ["formOrderNumberPlaceholder", "订单的ID、关键词", "訂單的ID、關鍵字", "注文のID、キーワード", "ID, keywords of order"],
      ["btn1", "流通-出系", "流通-出系", "流通-出系", " Distribution-Outsys"], // 原 商品处理
      ["btn2", "库存盘点", "庫存盤點", "在庫棚卸", "Inventory Check"], // 原 盘点详情
      ["searchGoods", "商品", "商品", "商品", "Item"],
      ["searchGoods_input", "商品或SKU的ID、编号、名称", "商品或SKU的ID、編號、名稱", "商品かSKUのID、番号、名称", "ID, No., name of items or SKU"],
    ],



    "logistics": [
      ["createTime", "时间", "時間", "時間", "Time"],
      ["logisticsNo", "ID", "ID", "ID", "ID"],
      ["num", "商品总点数", "商品總點數", "商品合計点数", "Total number of items"],
      ["postage", "合计出系服务费(円)", "合計出系服務理费(円)", "合計出系手数料(円)", "Total Outsys Handling Fee(円)"],
      ["premium", "合计保费(円)", "合計保費(円)", "合計プレミアム費(円)", "Total Premium Fee (円)"],
      ["aPickUp", "取货地址", "取貨地址", "受取住所", "Pickup Address"],
      ["pickTime", "预计取货时间", "預計取貨時間", "受取予定時間", "Estimated Pickup Time"],
      ["pickTimeText", "订单确认后约3天", "訂單確認後約3天", "注文後約3日前後", "About 3 Days after Order"],
      ["price", "合计保费(円)", "合計保費(円)", "合計プレミアム費(円)", "Total Premium Fee  (円)"],
      ["status0", "待接单", "待接單", "確認待ち", "for Confirm."],
      ["status1", "待取货", "待取貨", "受取待ち", "for Pick-up"],
      ["status2", "入系中", "入系中", "入系中", "Insysing"], // 已取货
      ["status3", "已拒绝", "已拒絕", "拒否済", "Rejected"],
      ["status4", "申请取消中", "申請取消中", "取消申請中", "Applying for Cancel"],
      ["status5", "已取消", "已取消", "取消済", "Cancelled"],
      ["status6", "还盘中", "還盤中", "条件交渉中", "in Counteroffer."], // 待平台确认
      ["status7", "已完成", "已完成", "完了済", "Completed"], // 待平台确认
      ["skuID", "skuID", "skuID", "skuID", "skuID"],
      ["goodsName", "商品名称", "商品名稱", "商品名称", "Item Name"],
      ["skuName", "SKU名称", "SKU名稱", "SKU名称", "SKU Name"],
      ["num", "商品总点数", "商品總點數", "商品合計点数", "Total number of items"],
      ["confirmClick","是否确定提交还盘？还盘被平台接受后该订单自动成立。该订单合计保费: ", "是否確定提交還盤？還盤被平台接受後該訂單自動成立。 該訂單合計保費: ", "条件交渉を提出しますがよろしいでしょうか？条件交渉がMilalaに受入された場合、この注文が成立しますので、ご了承ください。この注文の合計プレミアム費:", "Are you sure to submit the counteroffer? Please notice that if you submit it and platform take it, the order will be established.Total Premium Fee of the order: "],
    ],
    "logisticsDetail": [
      ["topTitle", "入系详情", "入系詳情", "入系詳細", "Insys Details"],
      ["btn1", "接单", "接單", "受ける", "Accept"], // 确认取货单
      ["btn2", "拒单", "拒單", "断る", "Reject"],
      ["btn3", "还盘", "還盤", "条件交渉", "Counteroffer"], // 请求修改
      ["btn4", "申请取消", "申請取消", "取消申請", "Apply for Cancel"],
      ["merchantStoreId","所属","所屬","所属","Belonging"],
      ["title0", "入系", "入系", "入系", "Insys"],
      ["title1", "商品", "商品", "商品", "Item"],
      ["return_title1", "退款说明", "待翻译", "待翻译", "待翻译"],
      ["return_title2", "退款凭证", "待翻译", "待翻译", "待翻译"],
      ["sureOrder", "是否确定接受该订单？该订单合计保费: ", "是否確定接受該訂單？該訂單合計保費:", "この注文を受け入れますがよろしいでしょうか？この注文の合計プレミアム費: ", "Are you sure to confirm this order?Total Premium Fee of the order:  "],
      ["cancelOrder", "是否确定拒绝该订单？", "是否確定拒絕該訂單？", "この注文を拒否しますがよろしいでしょうか？", "Are you sure to reject this order?"],
      ["todayPremium", "今日保价率", "今日保價率", "本日プレミアム率", "Premium Rate Today"],
      ["premium0", "普通", "普通", "通常品", "Ordinary"],
      ["premium1", "易损", "易損", "割れ物", "Fragile"],
      ["premium2", "特殊", "特殊", "特殊品", "Special"],
      ["cancel", "是否确定申请取消该订单？", "是否確定申請取消該訂單？", "この発注の取り消しを申請しますがよろしいでしょうか？", "Are you sure to apply for cancellation of this order?"],
      // 换盘
      ["editConfirm", "确认并提交", "確認並提交", "確認して提出", "Confirm and Submit"],
      ["editCancel", "取消并返回", "取消並返回", "取消して戻る", "Cancel and Back"],
    ],






    "inventory": [
      ["btn1", "处理普通盘亏", "處理普通盤虧", "一般異常処分", "Handel General Inventory"],
      ["btn2", "处理特殊盘亏", "處理特殊盤虧", "特殊異常処分", "Handel Special Inventory"],
      ["btn3", "确认差异盘亏", "確認差異盤虧", "差異異常確認", "Confirm Difference Inventory"],
      ["createTime", "时间", "時間", "時間", "Time"],
      ["stockCount", "应盘数量", "應盤數量", "帳簿棚卸数", "Book Inventory"],
      ["actualStock", "实盘数量", "實盤數量", "実地棚卸数", "Physical Inventory"],
      ["inventoryLossDifferenceNum", "差异盘亏", "差異盤虧", "差異異常", "Difference Loss"],
      ["inventoryLossOrdinaryNum", "普通盘亏", "普通盤虧", "一般異常", "General Loss"],
      ["inventoryLossSpecialNum", "特殊盘亏", "特殊盤虧", "特殊異常", "Special Loss"],
      // ["compensationPrice", "盘亏补偿(円)", "盤虧補償(円)", "異常補填(円)", "Loss Compensation(円)"],
      ["compensationPrice", "补偿金额(円)", "補償金額(円)", "補填金額(円)", "Compensation Amount(円)"],
      ["status0", "待处理", "待處理", "対応待ち", "for Disposing"], // 处理中
      ["status1", "部分已处理", "部分已處理", "一部処分済", "Partially Done"],// 已处理
      ["status2", "全部已完成", "全部已完成", "全部完了済", "All Completed"],
      ["statusDetail0", "待接单", "待接單", "確認待ち", "for Confirm"],
      ["statusDetail1", "待处理", "待處理", "対応待ち", "for Disposing"], // 待处理
      ["statusDetail2", "部分已处理", "部分已處理", "一部処分済", "Partially Disposed"],
      ["detailTime", "时间", "時間", "時間", "Time"],
      ["detailOrderId", "ID", "ID", "ID", "ID"],
      ["detailStatus", "状态", "狀態", "狀態", "Status"],
      ["detailNum", "已处理数量", "已處理數量", "対応済数", "Processed"],
      ["detailLeftNum", "未处理数量", "未處理數量", "未対応数", "for Process."],
      ["inventoryDetail", "库存盘点详情", "庫存盤點詳情", "在庫棚卸詳細", "Inventory Check Details"]
    ],





    "rolePage": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["formTimeC", "~", "~", "~", "~"],
      ["formroleName", "角色", "角色", "ロール", "Role"],
      ["formroleNamePlaceholder", "角色的ID、编号、名称", "角色的ID、編號、名稱", "ロールのID、番号、名称", "ID, No., name of role"],
      ["formStatus","状态", "狀態", "状態", "Status"],
      ["formStatusPlaceholder", "全部", "全部", "全て", "All"],
      ["add", "去开店!", "去開店!", "新規開店!", "Open a New Store!"],
      ["roleTitle", "功能权限", "功能權限", "機能権限", "Mightiness Authority"],
    ],

    "roleEdit": [
      ["addTtile", "添加角色", "添加角色", "ロール追加", "Add Role"],
      ["editTtile", "编辑角色", "編輯角色", "ロール編輯", "Edit Role"],
      ["detailTtile", "角色详情", "角色詳情", "ロール詳細", "Role Details"],
      ["noRoleName", "请输入(12字内)", "請輸入(12字內)", "ご入力ください(15文字内)", "Please enter(within 24 characters)"],
      ["menuAll", "权限设置", "權限設置", "権限設定", "Authority Setting"],
      ["noRokeKey", "请输入(15字节内)", "請輸入(15字節內)", "ご入力ください(15バイト内)", "Please enter (within 15 bytes)"],
      ["delRole", "是否确定删除该角色?", "是否確定刪除該角色?", "このロールを削除しますがよろしいでしょうか?", "Are you sure to delete this role?"],
      ["delRole2", "是否确定删除该角色?仍有账号属于该角色，删除后该账号将失去所有权限。", "是否確定刪除該角色?仍有賬號屬於該角色，刪除後該賬號將失去所有權限。", "このロールを削除しますがよろしいでしょうか?このロールに属するアカウントがまだ存在します。削除後、該当アカウントが全ての権限が失いますので、ご了承ください。", "Are you sure to delete this role? There are accounts still belongs to this role. The accounts will lose all authority after deleting."],
      ["delRole3", "是否确定删除该账号？信息删除后不可恢复，请悉知。", "是否確定刪除該賬號？信息刪除後不可恢復，請悉知。", "このアカウントを削除しますがよろしいでしょうか？情報を削除した後は復元できませんので、ご了承ください。", "Are you sure to delete the account? Please notice that deleted information cannot be restored."],
    ],

    "role": [
      ["roleName", "名称", "名稱", "名称", "Name"],
      ["roleId", "ID", "ID", "ID", "ID"],
      ["roleKey", "编号", "編號", "番号", "No"],
      ["merchantStoreIds", "店铺权限", "店鋪權限", "店舗権限", "Store Authority"],
      [" -", " -", "-", "-", "-"],
    ],



    "audit": [
      ["createTime", "申请时间", "申请时间", "申請時間", "申請時間"],
      ["frozenTime", "冻结时间", "凍結時間", "ロック時間", "Blocking Time"],
      ["id", "案件ID", "案件ID", "ケースID", "Case ID"],
      ["content", "事项", "事項", "事項", "Matter"],
      ["reason", "反馈", "反饋", "理由", "Feedback"],
      ["status", "状态", "狀態", "状態", "Status"],
      ["frozenId", "案件ID", "案件ID", "ケースID", "Case ID"],
      ["frozeReason", "说明", "說明", "説明", "Instructions"],
      ["failure", "详情", "詳情", "詳情", "Details"],
      ["type", "事项", "事項", "事項", "Matters"],

      ["frozenStatus1", "已解冻", "已解凍", "ロック解除済", "Unblocked"],
      ["frozenStatus2", "申请解冻中", "申請解凍中", "ロック解除申請中", "Applying for Unblock"],
      ["frozenStatus3",  "冻结中", "凍結中", "ロック中", "Blocked"],


      ["status0", "待处理", "待處理", "対応待ち", "for Process"],
      ["status1", "已通过", "已通過", "承認済", "Approved"],
      ["status2", "已驳回", "已駁回", "却下済", "Rejected"],
      ["status3", "已取消", "已取消", "取消済", "Canceled"],
      ["rejectTime", " ", " ", " ", " "],
    ],






    "auditError": [
      ["type1", "开店", "開店", "ストア開店", "Store Opening"],
      ["type2", "修改店铺信息", "修改店鋪信息", "ストア情報変更", "Store Information"],
      ["type3", "修改商品信息", "修改商品信息", "アイテム情報変更", "Item Information"],
      ["type4", "解冻商品", "解凍商品", "アイテムロック解除", "Product Unblocking"],
      ["type5", "解冻内容", "解凍內容", "コンテンツロック解除", "Contents Unblocking"],
      ["type6", "商品评价申诉", "商品評價申訴", "アイテムレビュー削除", "Item Review Deletion"],
      ["type7", "解冻账号", "解凍帳號", "アカウントブロック解除", "Account Unblocking"],
      ["type8", "解冻店铺", "解凍店鋪", "ストアロック解除", "Store Unblocking"],
      ["type9", "注销店铺", "註銷店鋪", "ストア廃業", "Store Shuttering"],
      ["type10", "解约账号", "解約帳號", "アカウント解約", "Account Termination"],
      ["type11", "修改卖家信息", "修改賣家信息", "セラー情報変更", "Modify seller information"],

    ],

    "thaw": [
      ["createTime", "申请时间", "申請時間", "申請時間", "Application Time"],
      ["id", "解冻申请ID", "解凍申請ID", "ロック解除申請ID", "Unblock Request ID"],
      ["content", "说明", "說明", "説明", "Description"],
      ["applyContent", "说明", "說明", "説明", "Instructions"],
      ["reason", "反馈", "反饋", "理由", "Feedback"],
      ["status", "状态", "狀態", "状態", "Status"],
      ["frozenId", "冻结ID", "凍結ID", "ロックID", "Block ID"],
      ["frozeReason", "冻结原因", "凍結原因", "ロック原因", "Block Reason"],
      ["thawContent", "请输入", "請輸入", "ご入力ください", "Please enter"],

      ["frozenType1", "待处理", "待處理", "対応待ち", "for Process"],
      ["frozenType2", "已通过", "已通過", "承認済", "Approved"],

      ["status0", "待处理", "待處理", "対応待ち", "for Process"],
      ["status1", "已通过", "已通過", "承認済", "Approved"],
      ["status2", "已驳回", "已駁回", "却下済", "Rejected"]
    ],





    "banner": [
      ["detail", "推广详情", "推廣詳情", "プロモーション詳細", "Promotion Details"],
      ["add", "站内推送下单", "站內推送下單", "アプリ押注文", "Order App. Push"],
      ["accepted", "Milala接受了您的推广申请", "Milala接受了您的推廣申請", "プロモーション注文はMilalaに確認されました。", "Your promotion order is accepted by Milala"],
      ["refuse", "Milala拒绝了您的推广申请", "Milala拒絕了您的推廣申請", "プロモーション注文はMilalaに拒否されました。", "Your promotion order is rejected by Milala"],

      ["sure", "提交订单", "提交訂單", "注文する", "Submit Order"],
      ["position", "位置", "位置", "位置", "Place"],
      ["dayPrice", "单天价格(円)", "單天價格(円)", "一日当価格(円)", "One Day Price (円)"],
      ["noPosition", " ", " ", " ", " "],
      ["showTime", "展示期间", "展示時間", "展示期間", "Display Period"],
      ["noShowTime", " ", " ", " ", " "],
      ["remark", "链接ID", "鏈接ID", "リンクID", "Link ID"],
      ["noRemark", "请输入该想要链接的店铺或商品或内容的ID等", "請輸入該想要鏈接的店鋪或商品或內容的ID等", "このプロモーションのリンク先の店舗や商品またはコンテンツのID等をご入力ください", "Please enter the ID of the store or product or contents you want to link to and so on"],
      ["addOrder", "是否确定申请购买该广告？该订单总价为", "是否確定申請購買該廣告？該訂單總價為", "このプロモーション注文を申請しますが、よろしいでしょうか？このプロモーション注文の合計価格は", "Are you sure to apply for this promotional order? The Total price of this promotional order is"],
      ["addOrder_price", "円", "円", "円です。", "円"],
      ["formTime", "时间", "時間", "時間", "時間"],
      ["reason", "拒绝说明", "拒絕說明", "拒否説明", "Rejection Description"],
      ["id", "推广", "推廣", "プロモーション", "Promotion"],
      ["idInput", "推广的ID", "推廣的ID", "プロモーションのID", "ID of promotion"],
      ["status0", "待接单", "待接單", "確認待ち", "for Confirm"], // 待审核
      ["status1", "已确认", "已確認", "確認済", "Confirmed"],
      ["status2", "已拒绝", "已拒絕", "拒否済", "Rejected"],
      ["status3", "已完成", "已完成", "完了済", "Completed"],
      ["status4", "已取消", "已取消", "取消済", "Cancelled"],
      ["formStatus1", "-", "-", "-", "-"],
      ["closeText", "是否确定撤销该申请?", "是否確定撤銷該申請?", "この申請を撤回しますがよろしいでしょうか?", "Are you sure to withdraw this application?"],
      ["tableId", "ID", "ID", "ID", "ID"],
      ["totalPrice", "合计价格(円)", "合計價格(円)", "合計価格(円)", "Total Price (円)"],
    ],





    "messageOrder": [
      ["content", "消息", "消息", "メッセージ", "Message"],
      ["time", "时间", "時間", "時間", "Time"],
    ],

    "customerService": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["id", "反馈", "反饋", "問い合わせ", "Inquiry"],
      ["issue", "事项", "事項", "事項", "Matter"],
      ["title", "反馈的标题", "反饋的標題", "問い合わせの標題", "Title of Inquiry"],
      ["typeStr", "反馈事项", "反馈事项", "問い合わせ事項", "Inquiry Matter"],
      ["status0", "解决中", "解決中", "解決中", "Resolving"], // 原 未处理
      ["status1", "已完结", "已完結", "終了済", "Overed"],
      ["status2", "已回复", "已回复", "返信済", "Replied"], // 原 部分已处理
      ["status", "状态", "状態", "状態", "Status"],
      ["content", "反馈详情", "反饋詳情", "問い合わせ詳細", "Inquiry Details"],
      ["upload", "图(选填)", "圖(选填)", "図 (任意)", "Photo (Optional)"],
      ["help", "帮助", "幫助", "ヘルプ", "Help"],

      ["noId", "反馈的标题", "反饋的標題", "問い合わせの標題", "Title of Inquiry"],

      ["add", "询问或反馈新问题", "詢問或反饋新問題", "新しい問い合わせを始める", "Create a new case"],
      ["add2", "反馈新问题", "反饋新問題", "新規問い合わせ", "New Inquiry"],

      ["sure", "提交", "提交", "提出", "Submit"],
      ["noInputTitle", "请输入(15字内)", "請輸入(15字內)", "ご入力ください(15文字以内)", "Please enter (within 30 bytes)"],
      ["noInputContent", "请输入详细的问题描述。\n我们会尽快联系您，请耐心等待。", "請輸入詳細的問題描述。\n我們會儘快聯繫您，請耐心等待。", "詳細なお問い合わせ内容をご入力ください。\n私共は早めの問題解決に努めますので、しばらくお待ちください。", "Please describe your problem. \nWe will contact you as soon as possible. "],
    ],

    "csHelp": [
      ["oneItem", "感谢您使用本系统。请问您想咨询哪方面的问题? ", "感謝您使用本系統。請問您想諮詢哪方面的問題?", "いつもありがとうございます。何についてお問い合わせしたいでしょうか?", "Thank you for using this system. What would you like to ask?"],
      ["twoItem", "您需要问什么类型的问题? ", "您需要問什麽類型的問題?", "お問い合わせ内容のカテゴリーを下記よりお選びください。", "Please select the category of your inquiry."],
      ["threeItem", "您的具体问题是什么?", "您的具體問題是什麽?", "お問い合わせ内容の詳細を下記よりお選びください。", "Please select the Contents of your inquiry. "],
      ["isComplete", "请问您的问题是否解决了?", "請問您的問題是否解決了?", "問題が解決されましたか?", "Did you solve the problem?"],
      ["complete", "十分抱歉给您带来了不便。请问是否有其他问题需要咨询?", "十分抱歉給您帶來了不便。 請問是否有其他問題需要諮詢？", "ご不便をおかけ、申し訳ございませんでした。その他問題がありますか?", "Do you have any other problem?"],
      ["complete1", "解决了", "解決了", "はい、解決しました", "Yes. It has been solved"],
      ["complete2", "没解决，联系人工客服", "沒解決，聯系人工客服", "いいえ、オペレーターに連絡", "No. I need to contact operator"],
      ["complete3","还有其他问题","還有其他問題","はい、まだあります","Yes, quest"],
      ["complete4","没有了，关闭窗口","沒有了，關閉窗口","沒有了，關閉窗口","No, close the window"],
    ],
    "csDetail": [
      ["topTitle", "小二", "小二", "コンシェルジュ", "Concierge"],
      ["btn1", "回复", "回复", "返信", "Reply"],
      ["noInput", "若有追加提问请在此输入", "若有追加提問請在此輸入", "追加質問があればここに入力", "Enter additional questions"],
      ["btn2", "终结案件", "終結案件", "ケース終了", "End the case"],
      ["title1", "说明", "說明", "説明", "Directions"],
      ["title2", "记录", "記錄", "記録", "Record"],
      ["noInputReply", "请输入回复内容", "待翻译", "待翻译", "待翻译"],
      ["close", "是否确定终结此反馈事项?", "是否確定終結此反饋事項?", "このケースを終了しますが、よろしいでしょうか?", "Are you sure to end this case?"],
      ["one", "反馈", "反饋", "問い合わせ", "Inquiry"],
      ["submit", "提交", "提交", "提出", "Submit"],
    ],





    "wallet": [
      ["dataTitle1", "当前总余额(円)", "當前總余額(円)", "現在合計残(円)", "Current Total Balance (円)"],
      ["dataTitle2", "冻结中余额(円)", "凍結中余額(円)", "ロック中残(円)", "Frozen Balance (円)"],
      ["dataTitle3", "提现中余额(円)", "提現中余額(円)", "ペイメント中額(円)", "Paying Balance (円)  "],
      ["dataTitle4", "可提现余额(円)", "可提現余額(円)", "ペイメント可能(円)", "Payable Balance (円)  "],
      ["dataTitle5", "本月已结算余额", "待翻译", "待翻译", "待翻译"],
      ["apply", "申请提现", "申請提現", "ウィズロー請求", "Request Payment"], // 申请提前结算
      ["recharged", "申告充值", "申告充值", "チャージ申告", "Declare Recharged"], // 申请提前结算

      ["lookDetail", "收支明细", "收支明細", "収支明細", "Balance Details"],
      ["createTime", "时间", "時間", "時間", "Time"], // 结算日期
      ["id", "ID", "ID", "ID", "ID"], // 结算ID
      ["price", "金额(円)", "金額(円)", "金額(円)", "Amount(円)"], // 结算金额
      ["balance", "余额(円)", "余額(円)", "残高(円)", "Balance(円)"], // 账户余额
      ["lookUp", "查看结算规则说明", "待翻译", "待翻译", "待翻译"],
      ["applyText1", " 您确定要申请提前取现吗?申请后不可撤销。", "您確定要申請提前提現嗎?申請後不可撤銷。", "ウィズローをリクエストしますか?申請後キャンセルできませんので、ご了承ください。", "Do you want to request withdraw right now? This operation cannot be canceled. Current Withdrawable "],
      ["applyText2", "当前可结算金额：", "當前可結算金額:", "現在ウィズロー可能残:", "Balance:"],
      ["applyText3", "提前结算手续费", "提前結算手續費", "都度ウィズロー手数料", "Withdraw in Advance Fee"],
      ["applyText4", "提前结算实际金额:", "提前結算實際金額: ", "実質ウィズロー額: ", "Actual Withdraw Amount: "],

      ["recharedText1", "您确定已向指定金融机关充值了吗?", "您確定已向指定金融機關充值了嗎?", "指定の金融機関に確かに振り込みを行いましたか?", "Are you sure you have recharged to the designated financial institution?"],
      ["recharedText2", "请在汇款后再进行操作。", "請在匯款後再進行操作。", "振込完了後この操作を行ってください。", "Please do so after completing recharging. "],
      ["recharedText3", "若确定，请输入您此次充值的金额", "若確定，請輸入您此次充值的金額", "確認しましたら、振り込んだ金額をご入力ください。", "If yes, please enter the amount of your recharge"],
      ["recharedNoInput", "0~999999的半角整数", "0~999999的半角整数", "0~999999の半角整数", "half-width integer between 0~999999"],

      
      
      ["status1", "提现", "提現", "ウィズロー", "Withdraw"],
      ["status2", "充值", "充值", "チャージ", "Recharge"],
      ["walletStatus1", "已结算", "已結算", "精算済", "Settled"],
      ["walletStatus2", "未结算", "未結算", "精算中", "Settling"],

      // ["withdrawal", "余额小于手续费时无法进行提前结算", "餘額小於手續費時無法進行提前結算", "残高が手数料を下回るとウィズローできません", "Withdraw cannot be requested when balance being less then advance fee"],
      ["withdrawal", "当前无可提现金额", "當前無可提現金額", "現在引き出せる金額はありません", "There is currently no amount withdrawal amount"],

      [
        "noStorage_head",
        "您本月的免费平均内存余量已不足10%，若超出，本月将针对超额部分按 ",
        "您本月的免費平均內存餘量已不足10%，若超出，本月將針對超額部分按 ",
        "本月の無料平均ストレージ残量が10％未満です。超過する場合、超過分に対して当月 ",
        "Your remaining storage for the month is less than 10%. If you exceed the free storage limit, you will be charged an additional fee of "
      ],
      [
        "noStorage_tail",
        " 円/G的价格另外收取系统使用费。",
        " 円/G的價格另外收取系統使用費。",
        " 円/Gのシステム利用料がかかりますので、ご注意ください。",
        " 円/G."
      ]
    ],







    "statistical": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["type", "类型", "類型", "タイプ", "Type"], // 收支类型
      ["content", "事项", "事項", "事項", "Matter"],
      ["contentId", "内容 ID", "内容 ID", "コンテンツID", "コンテンツID"],

      ["menu1", "收支明细", "收支明細", "収支明細", "Balance Details"],
      ["menu2", "交易统计", "交易統計", "取引統計", "Transaction Statistics"],
      ["menu3", "商品统计", "商品統計", "商品データ", "Item Statistics"],
      ["menu4", "流转明细", "流轉明細", "移動明細", "Movement Details"], // 原 库存统计
      ["menu5", "顾客统计", "顧客統計", "顧客統計", "User statistics"],

      ["dataType", "数据盘", "数据盘", "ダッシュボード", "Dashboard"],
      ["merchantOrder", "商城订单", "商城訂單", "モール注文", "Mall Order"],
      ["tradeTitle1", "收入与支出", "收入與支出", "収入と支出", "Income and Expenditure"],
      ["tradeTitle2","损益","損益","損益","Profit and Loss"],
      ["goodsSaleTitle1", "按分类", "按分類", "カテゴリ別", "By Category"],
      ["goodsSaleTitle2", "按商品", "按商品", "アイテム別", "By Item"],
      ["goodsSaleTitle3", "按SKU", "按SKU", "SKU別", "By SKU"],

      ["userTitle1", "买家数据", "買家數據", "バイヤーデータ", "Buyer Data"],

      ['reType1',"收入","收入","収入","Income"],
      ['reType2',"支出","支出","支出","Expenditure"],
      ['reType3',"提现","提現","ペーメイン","Payment"],
      ['reType4',"充值","充值","チャージ","Recharge"],

      ['type1_item1',"销售","銷售","販売","Sales"],
      ['type1_item2',"流通服务费","流通服務費","流通手数料","Distribution Fee"],

      ['Balance_Ending',"期末余额","期末餘額","期末残高","Balance Ending"],
      ['Balance_Beginning',"期初余额","期初餘額","期首残高","Balance Beginning"],
      ['Income_Period',"期间收入","期間收入","期間収入","Income Period"],
      ['Expenditure_Period',"期间支出","期间支出","期間支出","Expenditure Period"],
      ['Recharge_Period',"期间充值","期間充值","期間預入","Recharge Period"],
      ['Withdraw_Period',"期间提现","期間提現","期間引出","Withdraw Period"],
      ['Benefit_Period',"期间损益","期間損益","期間損益","Benefit Period"],
      ['Sale_Benefit',"销售损益","銷售損益","販売損益","Sale Benefit"],
      ['Other_Benefit',"其他损益","其他損益","其他損益","Other Benefit"],

      ['Inventory_Ending','期末总库存','期末總庫存','期末合計在庫','End Total Stock'],
      ['Inventory_Beginning','期初总库存','期初總庫存','期首合計在庫','Begin Total Stock'],
      ['Total Receipt Period','期间总入库','期間總入庫','期間合計入庫','Period Total Insys'],
      ['Issue Sales','期间销售出系','期間銷售出系','期間販売出系','Period Mall Sales Outsys'],
      ['periodTransshipOutsys','期间转运出系','期間轉運出系','期間転送出系','Period Transship Outsys'],
			['periodDestroyOutsys', '期间销毁出库', '期間銷毀出系', '期間廃棄出系', 'Period Destroy Outsys'],
			["OtherReceipt", "期间其他入库", "期間其他出系", "期間其他出系", "Period Other Outsys"],
      ['','普通处理出库','','',''],
      ['','盘亏处理出库','','',''],
      
      ['usetType','用户类型','用戶類型','ユーザータイプ','User Type'],
      ['oldUser','新买家','新買家','新規バイヤー','New Buyer'],
      ['newUser','老买家','老買家','既存バイヤー','Exist Buyer'],
      ['orderPersonNum','商城成交人数','商城成交人數','モール成立人数','Mall Succeed Person'],
      ['refundPersonNum','退款成交人数','退款成交人數','返金成立人数','Refund Succeed Person'],

      ['','盘亏处理出库','','',''],
      ['price','单价(円)','單價(円)','単価(円)','Unit Price (円)'],
      ['balance','总价(円)','總價(円)','総額(円)','Total Price (円)'],
      ['merchantBalance','余额(円)','余額(円)','残高(円)','Balance (円)'],

    ],



    "movement": [
      ["sku", "SKU编号", "SKU編號", "SKU番号", "SKU No."],
      ["goodsName", "商品", "商品", "アイテム", "Item Name"],
      ["sku2", "SKU名", "SKU名", "SKU名", "SKU Name"],
      ["Insys_Platform_Distribution", "平台流通入系", "平台流通入系", "Milala流通入系", "Insys Platform Distribution"],
      ["Receipt Mall Return", "商城退货入库", "商城退貨入庫", "モール返品入庫", "Receipt Mall Return"],
      ["Insys Difference Inventory", "差异盘盈入系", "差異盤盈入系", "差異異常確認入系", "Insys Difference Inventory"],
      ["Other Receipt", "其他入库", "其他入庫", "其他入庫", "Other Receipt"],
      ["Issue Sales", "销售出库", "銷售出庫", "販売出庫", "Issue Sales"],
      ["Outsys Transfer", "普通转运出系", "普通轉運出系", "普通転送出系", "Outsys Transfer"],
      ["Outsys Destruction", "普通销毁出系", "普通銷毀出系", "普通廃棄出系", "Outsys Destruction"],
      ["Outsys General Inventory Transfer", "普通盘亏转运出系", "普通盤虧轉運出系", "一般異常転送出系", "Outsys General Inventory Transfer"],
      ["Outsys General Inventory Destruction", "普通盘亏销毁出系", "普通盤虧銷毀出系", "一般異常廃棄出系", "Outsys General Inventory Destruction"],
      ["Outsys Special Inventory Transfer", "特殊盘亏转运出系", "特殊盤虧轉運出系", "特殊異常転送出系", "Outsys Special Inventory Transfer"],
      ["Outsys Special Inventory Destruction", "特殊盘亏销毁出系", "特殊盤虧銷毀出系", "特殊異常廃棄出系", "Outsys Special Inventory Destruction"],
      ["Outsys Difference Inventory", "差异盘亏确认出系", "差異盤虧確認出系", "差異異常確認出系", "Outsys Difference Inventory"],
      ["Other Issue", "其他出库", "其他出庫", "其他出庫", "Other Issue"],
      ["Amount", "数量", "數量", "数量", "Amount"],
      ["Total Balance of Selling Inventory", "剩余总可售库存", "剩餘總可售庫存", "販売可在庫残高", "Selling Stock Balance"],
      ["Total Balance of Other Inventory", "剩余其他库存", "剩餘其他庫存", "其の他在庫残高", "Other Stock Balance"],
    ],




    "statisticalCode":[
      ['type1_1',"销售","銷售","販売","Sales"],
      ['type1_2',"流通服务费返还","流通服務費返還","流通手数料返却","Distribution Fee Refund"],
      ['type1_3',"销售服务费返还","銷售服務費返還","販売手数料返却","Commission Fee Refund"],
      ['type1_4',"盘亏补偿","盤虧補償","異常補填","Loss Compensation"],
      ['type1_5',"其他收入","其他收入","其他収入","Other Income"],
      ['type1_6',"广告订单取消退款","其他收入","其他収入","Other Income"],


      ['type2_1',"流通服务费","流通服務費","流通手数料","Distribution Fee"],
      ['type2_2',"销售服务费","銷售服務費","販売手数料","Commission Fee"],
      ['type2_3',"销售退款","销售退款","販売返金","Sales Refund"],
      ['type2_4',"售后服务费","售後服務費","アフターサービス手数料","After-service Fee"],
      ['type2_5',"保费","保費","プレミアム費","Premium Fee"],
      ['type2_6',"卖家会费","賣家會費","セラー会費","Seller Membership Fee"],
      ['type2_7',"店铺赁费","店鋪賃費","ストア賃料","Store Rent Fee"],
      ['type2_8',"出系服务费支出","出系手續費支出","出系手数料支出","Outsys Fee Expenditure"],
      ['type2_9',"推广费","推廣費","プロモーション費","Promotion Fee"],
      ['type2_10',"结算手续费","結算手續費","決済手数料","Payment Fee"],
      ['type2_11',"其他支出","其他支出","其他支出","Other Expenditure "],

      ["suoKu", "锁库", "鎖庫", "鎖庫", "Stock Lock"],
      ["stockOut", "出库", "出庫", "出庫", "Stock Out"],
      ["stockAll", "全部类型", "全部類型", "全タイプ", "All Type"],
    ],


    "trade": [
      ["today", "本日", "本日", "本日", "Today"],
      ["toWeek", "本周", "本周", "本週", "This Week"],
      ["toMonth", "本月", "本月", "本月", "This Month"],
      ["formTime", " ", " ", " ", " "],  
      ["orderNum","商城下单单数","商城下單單數","モール注文数","Mall Orders"],
      ["sku","商城下单SKU点数","商城下單SKU點數","モール注文SKU点数","Mall Order SKU Points"],
      
      ["orderPrice","商城下单金额(円)","商城下單金額(円)","モール注文金額(円)","Mall Order Amount(円)"],
      ["orderDealNum","商城成交单数","商城成交單數","モール成立注文数","Mall Succeed Orders"],

      ["orderDealSkuNum","商城成交SKU点数","商城成交SKU點數","モール成立SKU点数","Mall Succeed SKU Points"],
      ["orderDealPrice","商城成交金额(円)","商城成交金額(円)","モール成立金額(円)","Mall Succeed Amount(円)"],
      ["orderCompleteNum","商城完成单数","商城完成單數","モール完了注文数","Mall Overed Orders"],
      ["orderCompleteSkuNum","商城完成SKU点数","商城完成SKU點數","モール完了SKU点数","Mall Overed SKU Points"],
      ["orderCompletePrice","商城完成金额(円)","商城完成金額(円)","モール完了金額(円)","Mall Overed Amount(円)"],
      ["refundSendNum","退款申请数","退款申請數","返金申請数","Refund Applications"],
      ["refundSendSkuNum","退款申请SKU点数","退款申請SKU點數","返金申請SKU点数","Refund SKU Points"],
      ["refundSendPrice","退款申请金额(円)","退款申請金額(円)","返金申請金額(円)","Refund Amount(円)"],
      ["refundDealNum","退款成交数","退款成交數","返金成立申請数","Refund Succeed Applications"],
      ["refundDealSkuNum","退款成交SKU点数","退款成交SKU點數","返金成立SKU点数","Refund Succeed SKU Points"],
      ["refundDealPrice","退款成交金额(円)","退款成交金額(円)","返金成立金額(円)","Refund Succeed Amount(円)"],
      ["refundCompleteNum","退款完成数","退款完成數","返金完了申請数","Refund Overed Applications"],
      ["refundCompleteSkuNum","退款完成SKU点数","退款完成SKU點數","返金完了SKU点数","Refund Overed SKU Points"],
      ["refundCompletePrice","退款完成金额(円)","退款完成金額(円)","返金完了金額(円)","Refund Overed Amount(円)"],
    ],


    "goodsSale": [
      ["goods", "商品", "商品", "アイテム", "Item"],
      ["noGoods", "商品或SKU的 ID、名称", "商品或SKU的 ID、名稱", "アイテムかSKUのID、名称", "ID, name of item or SKU"],

      ["category", "分类", "分類", "カテゴリ", "Category"],
      ["category2", "2级分类", "2級分類", "2階カテゴリ", "Secondary Category"],
      ["orderDealNum", "商城成交单数", "商城成交單數", "モール成立注文数", "Mall Succeed Orders"],
      ["orderDealPrice", "商城成交金额(円)", "商城成交金額(円)", "モール成立金額(円)", "Mall Succeed Amount (円)"],
      ["orderDealProportion", "商城完成额占比(%)", "商城完成額佔比(%)", "モール完了額割合(%)", "Mall Overed Share (%)"],

      ["refundDealNum", "退款成交单数", "退款成交單數", "返金成立申請数", "Refund Succeed Applications"],
      ["refundDealPrice", "退款成交金额(円)", "退款成交金額(円)", "返金成立金額(円)", "Refund Succeed Amount(円)"],
      ["refundDealProportion", "退款完成额占比(%)", "退款完成額佔比(%)", "返金完了額割合(%)", "Refund Overed Share (%)"],

      ['pieTitle1','商城成交单数-1级','商城成交單數-1级','モール成立注文数−1階','Mall Succeed Orders-1ry'],
      ['pieTitle2','商城成交单数-2级','商城成交單數-2级','モール成立注文数−2階','Mall Succeed Orders-2ry'],
      ['pieTitle3','商城成交金额-1级','商城成交金額-1级','成立金額−1階','Mall Succeed Amount-Primary'],
      ['pieTitle4','商城成交金额-2级','商城成交金額-2级','成立金額−2階','Mall Succeed Amount-Secondary'],

      ['lineTitle1','商城成交单数-商品','商城成交單數-商品','モール成立注文数−アイテム','Mall Succeed Orders-Item'],
      ['lineTitle2','商城成交单数-SKU','商城成交單數-SKU','モール成立注文数−SKU','Mall Succeed Orders-SKU'],
      ['lineTitle3','商城成交金额-商品','商城成交金額-商品','モール成立金額−商品','Mall Succeed Amount-Item'],
      ['lineTitle4','商城成交金额-SKU','商城成交金額-SKU','モール成立金額−SKU','Mall Succeed Amount-SKU'],
      


    ],
    "stock": [
      ["noGoods", "-", "-", "-", "-"],
      ["-", "-", "-", "-", "-"],
    ],





    "systemSessting": [
      ["title1", "个人资料", "個人資料", "プロフィール", "Profile"],
      ["updPassWord", "修改密码", "修改暗號", "パスワード変更", "Change Password"],
      ["title2", "语言", "語言", "言語", "Language"],
      ["title3", "版本", "版本", "バージョン", "Version"], // 版本	版本	バージョン	Version
      ["createTime", "时间", "時間", "時間", "Time"],
      ["ID", "ID", "ID", "ID", "ID"],
      ["nickName", "昵称", "暱稱", "ニックネーム", "Nickname"],
      ["userName", "姓名", "姓名", "名前", "Name"],
      ["roleName", "角色", "角色", "ロール", "Role"],
      ["phonenumber", "手机", "手機", "携帯", "Cellphone"],
      ["phonenumber_input", "手机号码", "手機號碼", "携帯番号", "Cellphone number"],
      // ["email", "邮箱", "郵箱", "メール", "Mail"],
      ["labelEmail", "当前邮箱:", "目前郵箱", "現メール", "Mail Now"],
      ["labelCode", "验证码:", "驗證碼", "認証コード", "Verify. Code"],
      ["labelPwd", "新密码:", "新密碼", "新パスワード", "New Password"],
      ["labelRePwd", "确认密码:", "確認密碼", "パスワード確認", "Confirm Password"],
      ["isGetCodeIn", "发送中", "發送中", "送信中", "Sending"],
      ["getCode", "获取验证码", "獲取驗證碼", "コード送信", "Send Code"],
      ["codePlaceholder", "验证码", "驗證碼", "認証コード", "Verification Code"],
      ["pwdPlaceholder", "新密码(>=6位，含英字及数字)", "新暗號(>=6位，含英字及數字)", "新パスワード(>=6桁、英字と数字混在)", "New Password(>=6 digits, incl. letter & No.)"],
      ["pwdRulesLength", "密码(>=6位，含英字及数字)", "暗號(>=6位，含英字及數字)", "パスワード(>=6桁、英字と数字混在)", "Password(>=6 digits, incl. letter & No.)"],
      ["rePwdPlaceholder", "请再次输入密码", "請再次輸入暗號", "再度パスワードをご入力ください", "Please enter password again"],
      ["authPwdAndRePwd", "两次输入的密码不一致", "兩次輸入的暗號不一致", "入力されたパスワードが一致しません", "The passwords entered twice do not match"],
      //23年4月13日 4.1.1.4文档 此页有4种提示，2次密码不一样、密码不符合要求、验证码为空或不符合要求或不匹配提示、其他情况
      // ["authPwdAndRePwd", "请再次输入密码", "請再次輸入暗號", "再度パスワードをご入力ください", "Please enter password again"],




        
    ],
    "evaluate": [
      ["btnList", "申诉", "申訴", "削除依頼", "Deletion Request"],
      ["formTime", "时间", "時間", "時間", "Time"],
      ["id", "评价", "評價", "レビュー", "Review"],
      ["id2", "评价ID", "評價ID", "レビューID", "Review ID"],

      ["orderId", "订单", "訂單", "注文", "Order"],
      ["goodsName", "商品", "商品", "アイテム", "Item"],
      ["userName", "顾客", "顧客", "顧客", "Customer"],



      ["evaluateIdPlaceholder", "评价的ID、关键词", "評價的ID、關鍵詞", "レビューのID、キーワード", "ID or keywords of review"],
      ["formOrderIdPlaceholder", "订单的ID", "訂單的ID", "注文のID", "ID of order"],
      ["formGoodsNamePlaceholder", "商品的ID、编号、名称", "商品的ID、編號、名稱", "アイテムのID、番号、名称", "ID, No., name of item"],
      ["formuserNamePlaceholder", "顾客的ID、昵称", "顧客的ID、暱稱", "顧客のID、ニックネーム", "ID, Nickname of customer"],

      ["status0", "待显示", "待顯示", "反映待ち", "Undisplayed"], // 未显示
      ["status1", "显示中", "顯示中", "反映済", "Displaying"],
      ["status2", "已删除", "已刪除", "削除済", "Deleted"],
      ["status3", "待处理", "待處理", "対応待ち", "for Process"],

      ["star", "星级", "星級", "星数", "Star"],
      ["star1", "1", "1", "1", "1"],
      ["star2", "2", "2", "2", "2"],
      ["star3", "3", "3", "3", "3"],
      ["star4", "4", "4", "4", "4"],
      ["star5", "5", "5", "5", "5"],
      ["goodsId", "商品 ID", "商品 ID", "アイテムID", "Item ID"],
      ["goodsName", "商品", "商品", "アイテム", "Item Name"],
      ["detail", "评价详情", "評價詳情", "レビュー詳細", "Review Details"],
      ["detail_appeal", "申诉详情", "申訴詳情", "削除依頼詳細", "Deletion Request Details"],
      ["detailDel", "申请删除", "申請刪除", "削除依頼", "Request for Deletion"],
      ["detailSs", "重新申诉", "重新申訴", "再申請", "Apply Again"],
      ["noRemark", "请输入申请说明", "請輸入申請說明", "購買依頼の説明を入力してください", "Please enter the application description"],
      ["detailTime1", "驳回说明", "駁回說明", "却下説明", "Rejection Reason"],
      ["detailTime2", "申请说明", "申請說明", "申請説明", "Application Explanation"],
      ["returnContent", "是否确定撤销申诉", "是否確定撤銷申訴", "削除依頼を取消しますがよろしいでしょうか?", "Are you sure to revoke the deletion request?"],

      ["del_noInput", "请详细说明申请删除该评价的原因(60字内)", "請詳細說明申請刪除該評價的原因(60字內)", "このレビューを削除依頼する理由を詳しくご説明ください。(60文字内)", "Please explain in detail why you are requesting this review to be deleted. (Within 120 characters)"],

      ["detailRuturn", "撤销申诉", "撤銷申訴", "申請取消", "Withdraw"]
    ],
    "appeal": [
      ["formTime", "时间", "時間", "時間", "Time"],
      ["id", "案件", "案件", "ケース", "Case"],
      ["id_placeholder", "案件的ID、关键词", "案件的ID、關鍵字", "ケースのID、キーワード", "ID, keywords of case"],

      ["createTime", "最近申诉时间", "最近申訴時間", "最近申請時間", "Last Request Time"],

      ["status0", "待处理", "待處理", "対応待ち", "for Process"],
      ["status1", "已驳回", "已駁回", "却下済", "Rejected"],
      ["status2", "已通过", "已通過", "承認済", "Approved"],
      ["status3", "已撤销", "已撤銷", "取消済", "Cancelled"]
    ],





    "staff": [
      ["account_search_input", "账号的ID、邮箱、昵称", "賬號的ID、郵箱、暱稱", "アカウントのID、メール、ニックネーム", "ID, email, nickname of account"],
      ["inputNewEmail", "新账号邮箱地址", "新賬號電郵位址", "新アカウントメールアドレス", "New Accountmail Address"],
      ["inputVerifyCode", "验证码", "驗證碼", "認証コード", "Verification Code"],
      ["pleaseSelect", "请选择", "請選擇", "お選びください", "Please select"],
      ["pleaseInput", "请输入手机号码", "請輸入手機號碼", "携帯番号をご入力ください", "Please enter cellphone number"],
      ["pleaseInput_1", "请输入(12字内)", "請輸入(12字節內)", "ご入力ください(15文字内)", "Please enter (within 24 characters)"],
      ["pleaseInput_2", "账号邮箱地址", "賬號電郵位址", "アカウントメールアドレス", "Accountmail Address"],
      ["avatar", "头像", "頭像", "アバター", "Avatar"],
      ["nickName", "昵称", "暱稱", "ニックネーム", "Nickname"],
      ["userName", "姓名", "姓名", "名前", "Name"],
      ["roleIds", "角色", "角色", "ロール", "Role"],
      ["phonenumber", "手机号码", "手機號碼", "携帯番号", "Cellphone"],
      ["account_search",  "账号", "賬號", "アカウント", "Account"], // account_search_input
      ["email",  "账号邮箱", "賬號郵箱", "アカウントメール", "Accountmail"],
      ["emailCode", "验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["sending", "发送中", "發送中", "送信中", "Sending"],
      ["emitEmailCode", "获取验证码", "獲取驗證碼", "コード送信", "Sent Code"],
      ["rePassword", "密码确认", "暗號確認", "パスワード再入力", "Reenter Password"],
      ["password", "密码", "暗號", "パスワード", "Password"],
      ["id", "编号", "編號", "番号", "No."],
      ["createTime", "时间", "時間", "時間", "Time"],
      ["addTtile", "添加账号", "添加賬號", "アカウント追加", "Add Account"],
      ["editTtile", "账号详情", "賬號詳情", "アカウント詳細", "Account Details"],
      ["editEmail", "修改邮箱", "修改電郵", "メールアドレス変更", "Account Info."],
      ["resetPassword", "修改密码", "修改暗號", "パスワード変更", "Change Password"],
      ["inputNewPassword", "密码(6位以上，含英字及数字)", "暗號(6位以上，含英字及數字)", "パスワード(6桁以上、英字と数字混在)", "Password(>=6 digits, include letter and No.)"],
      ["inputNewPasswordAgain", "请再次输入密码", "請再次輸入暗號", "再度パスワードをご入力ください", "Please enter password again"],
      ["samePassword", "两次输入的密码不一致", "兩次輸入的暗號不一致", "入力されたパスワードが一致しません", "The passwords entered twice do not match"],
        ["delStaffTips", "是否确定删除该角色吗？", "是否確定刪除該角色嗎？", "このロールを削除しますがよろしいでしょうか？", "Do you want to delete this role?"],
        ["delStaffTips2", "是否确定删除该角色?\n" +
        "仍有账号属于该角色，删除后该账号将失去所有权限。", "是否確定刪除該角色?\n" +
        "仍有賬號屬於該角色，刪除後該賬號將失去所有權限。", "このロールを削除しますがよろしいでしょうか?\n" +
        "このロールに属するアカウントがまだ存在します。削除後、該当アカウントが全ての権限が失いますので、ご了承ください。", "Are you sure to delete this role? \n" +
        "There are accounts still belongs to this role. The accounts will lose all authority after deleting."],
    ],
    "staffRule": [
      ["avatar", "-", "-", "-", "-"],
      ["nickName", "-", "-", "-", "-"],
      ["userName", "-", "-", "-", "-"],
      ["roleIds", "-", "-", "-", "-"],
      ["phonenumber", "-", "-", "-", "-"],
      ["email", "-", "-", "-", "-"],
      ["minPassword", "密码(6位以上，含英字及数字)", "暗號(6位以上，含英字及數字)", "パスワード(6桁以上、英字と数字混在)", "Password(>=6 digits, include letter and No.)"],
      ["email_1", "邮箱与验证码不匹配，无法完成验证", "郵箱與驗證碼不匹配，無法完成驗證", "メールアドレスと認証コードがマッチできず、認証が完了できません。", "The email address does not match the verification code, and the verification cannot be completed"],
      ["email_2", "无法验证，请确认信息填写正确", "無法認證，請確認信息填寫正確", "認証できませんでした,ご入力の情報が正しいかをご確認ください", "Cannot be verified,Please confirm that information you fill in corrected"],
      ["emailCode", "请输入验证码", "請輸入驗證碼", "認証コードを入力してください", "Please enter the verification code"],
      ["password", "请输入密码", "請輸入密碼", "パスワードをご入力ください", "Please enter password"],
      ["rePassword", "请确认登入密码", "請再次輸入密碼", "再度パスワードをご入力ください", "Please enter password again"],
    ],




    "main": [
      ["title1", "待处理", "待處理", "対応待ち", "Waiting for Response"],
      ["notConfirmedNum", "商城-通常订单(待接单)", "商城-通常訂單(待接單)", "モール-通常注文(確認待ち)", "Mall-Usually Order (for Confirm.)"],
      ["distributionPickUpNum", "商城-通常订单(待取货)", "商城-通常訂單(待取貨)", "モール-通常注文(受取待ち)", "Mall-Usually Order (for Pickup.)"],
      ["ctypeConfirmNum", "商城-线下交付(待处理)", "商城-線下交付(待處理)", "モール-オフライン(対応待ち)", "Mall- Offline (for Process.)"],
      ["newsNum", "未读顾客消息", "未讀顧客消息", "未読顧客メッセージ", "Unread Customer Message"],
      ["exitLoginTitle", "是否确定登出?", "是否確定登出?", "ログアウトしますがよろしいでしょうか?", "Are you sure to log out?"],
      ["exitLogin", "登出", "登出", "ログアウト", "Log Out"],
      ["afterSale", "商城-售后(待处理)", "商城-售後(待處理)", "モール-返金(対応待ち)", "Mall- Refund (for Process.)"],
      ["inventory", "盘点异常", "盤點異常", "棚卸異常", "Inventory Disposal"],
      ["notConfirmedLogisticsNum", "流通-入系(待接单)", "流通-入系(待接單)", "流通-入系(確認待ち)", "Distribution-Insys (for Confirm.)"],
      ["pickUpLogisticsNum", "流通-入系(待取货)", "流通-入系(待取貨)", "流通-入系(受取待ち)", "Distribution- Insys (for Pickup.)"],
      ["auditFailed", "已驳回一览", "已駁回一覽", "却下済リスト", "Rejected List"],
      ["exceptionStatus", "冻结中一览", "凍結中一覽", "ロックリスト", "Blocking List"],
      ["exceptionStatus2", "冻结中一览", "凍結中一覽", "ロックリスト", "Blocking List"],
      ["goOpen", "开店！", "開店！", "新規開店へ！", "Open a New Store！"],
      ["systemInfo", "指南", "指南", "マニュアル", "Manual"],
      ["totalTodayPrice", "本日销售总额(円)", "本日銷售總額(円)", "本日総売上高(円)", "Total Sales Today (円)"],
      ["totalMonthPrice", "本月销售总额(円)", "本月銷售總額(円)", "今月総売上高(円)", "Total Sales this Month (円)"],
      ["totalSevenPrice", "近7日销售总额(円)", "近7日銷售總額(円)", "7日間総売上高(円)", "Total Sales Past 7 Days (円)"],
      ["balance", "当下总余额(円)", "當下總餘額(円)", "現在合計残高(円)", "Total Balance Now (円)"],
      ["errorRecord", "已驳回一览", "已駁回一覽", "却下済リスト", "却下済リスト"],
      ["befrozed", "账号冻结", "帳號凍結", "アカウントブロック", "Account Block"],
      ["merchantId", "账号ID", "帳號ID", "アカウントID", "Account ID"],
    ],


    "reminder": [
      ["store", "店铺冻结", "店鋪凍結", "ストアブロック", "Store Block"],
      ["store02", "店铺驳回", "店鋪駁回", "店舗却下です", "Store rejection"],
      ["goods", "商品冻结", "商品凍結", "ストアブロック", "Item Block"],
      ["goods02", "商品驳回", "商品駁回", "商品却下です", "Rejection of goods"],
      ["content", "内容冻结", "內容凍結", "コンテンツブロック", "Contents Block"],
      ["content02", "内容驳回", "內容駁回", "內容拒絕", "Content rejection"],
    ],






    "goodsHandle": [
      ["title1", "出系", "出系", "出系", "Outsys"],
      ["status0", "待接单", "待接單", "確認待ち", "for Confirm."],
      ["status1", "出系中", "出系中", "出系中", "Outysing"],
      ["status2", "已完成", "已完成", "完了済", "Completed"],
      ["status3", "已取消", "已取消", "取消済", "Cancelled"],
      ["createTime", "时间", "時間", "時間", "Time"],
      ["orderNo", "订单", "訂單", "注文", "Order"],
      ["goodsId", "商品", "商品", "商品", "Item"],
      ["goodsIdInput", "商品或SKU的ID、编号、名称", "商品或SKU的ID、編號、名稱", "商品かSKUのID、番号、名称", "ID, No., name of item or SKU"],
      ["inventoryLoss", "类型", "類型", "タイプ", "Type"],
      ["key", "-", "-", "-", "-"],
      ["noInputorderNo", "订单的ID", "訂單的ID", "注文のID", "ID of order"],
      // 一般销毁
      ["loss1", "普通销毁出系", "普通銷毀出系", "普通廃棄出系", "Outsys Destruction"],
      // 一般转运
      ["loss2", "普通转运出系", "普通轉運出系", "普通転送出系", "Outsys Transfer"],
      // 普通盘亏销毁
      ["loss3", "普通盘亏销毁出系", "普通盤虧銷毀出系", "一般異常廃棄出系", "Outsys General Inventory Destruction"],
      // 普通盘亏转运
      ["loss4", "普通盘亏转运出系", "普通盤虧轉運出系", "一般異常転送出系", "Outsys General Inventory Transfer"],
      // 特殊盘亏销毁
      ["loss5", "特殊盘亏销毁出系", "特殊盤虧銷毀出系", "特殊異常廃棄出系", "Outsys Special Inventory Destruction"],
      // 特殊盘亏转运
      ["loss6", "特殊盘亏转运出系", "特殊盤虧轉運出系", "特殊異常転送出系", "Outsys Special Inventory Transfer"],
      // 确认差异盘亏
      ["loss7", "差异盘亏确认出系", "差異盤虧確認出系", "差異異常確認出系", "Outsys Difference Inventory"],
      
      ["addGoodsErrMsg", "-", "-", "-", "-"],
      ["postage", "出系服务费(円)", "出系服務费(円)", "出系手数料(円)", "Outsys Handling Fee(円)"],
      ["topTitle", "出系详情", "出系詳情", "出系詳細", "Outsys Details"],
      ["aPickUp", "转运目的地地址", "轉運目的地地址", "轉運目的地地址", "Transport Address"],
    ],
    "handleEdit": [
      ["topTitle", "添加出系订单", "添加出系訂單", "出系注文追加", "Add An Outsys Order"],
      ["topTitle2", "-", "-", "-", "-"],
      ["topTitle3", "-", "-", "-", "-"],
      ["key", "出系服务费(円):", "出系服務费(円)", "出系手数料(円)", "Outsys Handling Fee(円)"],
      ["add", "添加商品", "添加商品", "商品追加", "Add Item"],
      ["addBtn", "添加", "添加", "追加", "Add"],
      ["sureAdd", "提交订单", "提交訂單", "注文する", "Submit Order"],
      ["stock", "可处理库存", "總庫存", "総在庫数", "Total Inventory"],
      ["setTransferAddress", "转运目的地", "轉運目的地", "転送先", "Transport"],
      ["sureBtn", "确定并提交", "確定並提交", "確認して提出", "Confirm and Submit"],
      ["transferAddressLabel", "-", "-", "-", "-"],
      
      // 设置转运出库表单
      ["nickname", "收件人姓名", "收件人姓名", "受取人名前", "Consignee"], // 收件人姓名
      ["mobile", "手机号码", "手機號碼", "携帯番号", "Cellphone"], // 手机号
      ["districtcode", "邮政编码(半角数字)", "郵政編碼(半角數字)", "郵便番号(半角数字)", "zip code"],
      ["province", "都道府県", "都道府県", "都道府県", "Prefectures"],
      ["city", "市区町村", "市区町村", "市区町村", "Municipalities"],
      ["area", "町名番地", "町名番地", "町名番地", "Chome Address"],
      ["address", "详细地址(建筑物名、公司名、房号等)", "詳細地址(建築物、公司名、，房號等)", "それ以降(建物名、社名、部屋番号等)", "Details (Building name, room number, etc.)"],
      ["noZero", "商品数量不能为0", "待翻译", "待翻译", "待翻译"],
      ["exceedMax", "商品最大数量已超过库存数量", "待翻译", "待翻译", "待翻译"],
      ["confirmAddTransfer", "是否确定提出该库存处理订单？", "是否確定提出該庫存處理訂單？", "この在庫処分注文を提出しますが、よろしいでしょうか？", "Are you sure to submit this inventory handle order?"],
      ["confirmDelTransfer", "是否确定将此商品从列表移除？", "是否確定將此商品從列表中移除?", "この商品をリストから移出しますがよろしいでしょうか?", "Are you sure you to remove the product from the list?"]
    ],





    //收入与支出
    "IncomeAndExpenditure": [
      ["incomeItem", "收入事项", "收入事項", "収入事項", "Income Matter"],
      ["money", "金额(円)", "金額(円)", "金額(円)", "Amount(円)"],
      ["share", "占比(%)", "占比(%)", "割合(%)", "Share (%)"],
      ["payItem", "支出事项", "支出事項", "支出事項", "Expenditure Matter"],  
      ["orderNum","商城下单单数","商城下單單數","モール注文数","Mall Orders"],
      ["sale","销售","銷售","販売","Sale Benefit"],
      ["lossinventory","盘亏补贴","盤虧補貼","異常補填","Loss Compensation"],
      ["ohther","其他","其他","其他","Other"],

      ["logisticsServiceExpensePrice","流通服务费","流通服務費","流通手数料","Distribution Fee"],
      ["salesServiceExpensePrice","销售服务费","銷售服務費","販売手数料","Commission Fee"],
      ["afterServiceExpensePrice","售后服务费","售後服務費","返金手数料","Refund Fee"],
      ["storeRentExpensePrice","店铺赁费","店鋪賃費","ストア賃料","Store Rent Fee"],
      ["premiumExpensePrice","保费","保費","プレミアム費","Premium Fee"],
      ["makeExpensePrice","出系手续费","出系手續費","出系手数料","Outsys Fee"],
      ["promotionExpensePrice","推广费","推廣費","プロモーション費","Promotion Fee"],
      ["settleServiceExpensePrice","结算手续费","結算手續費","決済手数料","Payment Fee"],

    ],




    "loss":[
      ["orderLossItem", "商城订单损益事项", "商城訂單損益事項", "モール注文損益事項", "Mall Order Profit and Loss Matter"],
      ["otherLossItem", "其他损益事项", "其他損益事項", "其の他損益事項", "Other Profit and Loss Matter"],

      ["loss","损益","損益","損益","Profit and Loss"],
      ["sale","销售(+)","銷售(+)","販売(+)","Sale(+)"],
      ["logisticsServiceExpensePrice","流通服务费(-)","流通服務費(-)","流通手数料(-)","Distribution Fee(-)"],
      ["salesServiceExpensePrice","销售服务费(-)","銷售服務費(-)","販売手数料(-)","Commission Fee(-)"],
      ["afterServiceExpensePrice","售后服务费","售後服務費","返金手数料","Refund Fee"],


      ["otherIncomePrice","其他(+)","其他(+)","其他(+)","Other(+)"],
      ["storeRentExpensePrice","店铺赁费(-)","店鋪賃費(-)","ストア賃料(-)","Store Rent Fee(-)"],
      ["premiumExpensePrice","保费(-)","保費(-)","プレミアム費(-)","Premium Fee(-)"],
      ["makeExpensePrice","出系服务费(-)","出系手續費(-)","出系手数料(-)","Outsys Fee(-)"],
      ["promotionExpensePrice","推广费(-)","推廣費(-)","プロモーション費(-)","Promotion Fee(-)"],
      ["settleServiceExpensePrice","结算手续费(-)","結算手續費(-)","決済手数料(-)","Payment Fee(-)"],
      ["otherExpensePrice","其他(-)","其他(-)","其他(-)","Other(-)"],
      
    ],





    "common": [
      ["search", "确定", "確定", "確定", "Comfirm"],
      ["reset", "取消", "取消", "取消", "Cancel"],
      ["noInput", "请输入", "請輸入", "ご入力ください", "Please enter"],
      ["noInput1", "请输入(选填)", "請輸入(選填)", "ご入力ください(オプション)", "Please enter(optional)"],
      ["noInput2", "请输入 (必填)", "請輸入 (必填)", "ご入力ください (必須)", "Please enter (required)"],
      ["noInputFrozen", "请输入关于本次冻结的具体信息和说明方便我们查询并帮助您解冻", "請輸入關於本次凍結的具體資訊和說明方便我們查詢並説明您解凍", "このブロック案件について詳しくご入力ください。Milalaのスタッフがそれを確認した上でブロック解除について判断致します。", "Please enter the reason why you can apply for unblocking."],
      ["noSelect", "请选择", "請選擇", "お選びください", "Please select"],
      ["noData", "-", "-", "-", "-"],
      ["noAdd1", "邮政编码(半角数字, 例: 1608338)", "郵政編碼(半角數字, 例: 1608338)", "郵便番号(半角数字, 例: 1608338)", "Zip code (Half-width numbers,  E.g.: 1608338)"],
      ["noAdd2", "国家地区, 省份等(例: 日本国東京都)", "國家地區, 省份等(例: 日本国東京都)", "国か地域, 都道府県等(例: 日本国東京都)", "Country or Region, State, Province(E.g.: Japan Tokyo)"],
      ["noAdd3", "地方市区县乡街道等(例: 新宿区)", "地方市區縣鄉街道等(例: 新宿区)", "市区町村等(例: 新宿区)", "Municipalities, City (E.g.: Shinjyuku-ku)"],
      ["noAdd4", "路名小区门牌号等(例: 西新宿1-33-1)", "路名小區門牌號等(例: 西新宿1-33-1)", "町名番地号等(例: 西新宿1-33-1)", "Street, number, etc. (E.g.: Nishishinjyuku 1-33-1)"],
      ["noAdd5", "其他：如建筑名公司名房间号(选填、例: Mini Station 101) ", "其他：如建築名公司名房間號(選填、例: Mini Station 101)", "その他: 建物や社名部屋番号等(あれば、例:ミニステーション101)", "Others: building, room number, etc. (Option、 E.g.: Mini Station 101)"],
      
      ["noInputCode", "验证码", "驗證碼", "認証コード", "Verify. Code"],
      ["id","ID","ID","ID","ID"],
      ["typeStr","事项","事項","事項","Matter"],
      ["title","标题","標題","標題","Title"],
      ["detail","详情","詳情","詳細","Detail"],
      ["clickDetail1","点此去接单","點此去接單","クリックして注文確認へ","Click here for Confirming"],
      ["clickDetail2","点此查看详情","點此查看詳情","クリックして詳細を確認する","Click here for Details"],
      ["success", "成功", "成功", "できしました", "Succussed"],


      ["status", "状态", "狀態", "状態", "Status"],
      ["func", "操作", "操作", "操作", "Operation"],
      ["sure", "确定", "確定", "確定", "Comfirm"],
      ["cancel", "取消", "取消", "取消", "Cancel"],
      ["money", "円", "円", "円", "円"],
      ["noNumber", "只能为数字", "只能為數字", "待翻译", "待翻译"],
     
 ["chooseLaugh", "语言", "語言", "言語", "Language"],
      ["noStore", "还没有店铺", "還沒有店鋪", "まだストアがありません", "There is no store now"],
      ["noImg", "-", "-", "-", "-"],
      ["updateSuccess", "成功", "成功", "できました", "Succeed"],
      ["formTimeC", "~", "~", "~", "~"],
      ["mainImage", "主图像", "主圖像", "メイン図", "Main Picture"],
      ["frontImage", "正面照", "正面照", "正面写真", "Front Photo"],
      ["add", "添加", "添加", "追加", "Add"],
      ["add2", "添加", "添加", "追加", "Add"],
      ["delete", "删除", "刪除", "削除", "Delete"],
      ["addGoods", "添加关联商品", "添加關聯商品", "関連アイテム追加", "Add Related Item"],
      ["viewDetail", "查看详情", "查看詳情", "詳細確認", "View Details"],
      ["edit", "编辑", "編輯", "編輯", "Edit"],
      ["params", "参数", "參數", "データ", "Data"],
      ["export", "导出", "導出", "ダウンロード", "Download"],
      ["refresh", "刷新", "刷新", "更新", "Refresh"],
      ["lookUp", "详情说明", "詳情説明", "詳細説明", "Details"],
      ["backoutEdit", "撤销编辑", "撤銷編輯", "編輯撤回", "Revoke Editing"],
      ["backoutApply", "撤销申请", "撤銷申請", "申請撤回", "Revoke Request"],

      ["formTimeS", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeE", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD", "YY/MM/DD"],
      ["formTimeC", "~", "~", "~", "~"],
      ["formUserId", "用户ID", "用户ID", "ユーザーID", "User ID"],

      ["formGoodsId", "商品 ID", "商品 ID", "アイテムID", "Item ID"],
      ["formPikerPlaceholder", "全部", "全部", "全て", "All"],

      ["formUserIdPlaceholder", "-", "-", "-", "-"],
      ["formGoodsIdPlaceholder", "-", "-", "-", "-"],

      ["Sunday", "周日", "周日", "日曜日", "Sunday"],
      ["Monday", "周一", "周一", "月曜日", "Monday"],
      ["Tuesday", "周二", "周二", "火曜日", "Tuesday"],
      ["Wednesday", "周三", "周三", "水曜日", "Wednesday"],
      ["Thursday", "周四", "周四", "木曜日", "Thursday"],
      ["Friday", "周五", "周五", "金曜日", "FrIDay"],
      ["Saturday", "周六", "周六", "土曜日", "Saturday"],
      ["monthPicker", "MM/DD", "MM/DD", "MM/DD", "MM/DD"],
      ["allStore", "整体", "整體", "全体", "Overall"],
      ["allStore2", "卖家整体", "賣家整體", "セラー全体", "Overall"],
      ["allStore3", "全部", "全部", "全て", "All"],
      ["tips", "温馨提示", "温馨提示", "ご注意", "Notice"],
      ["save", "保存", "保存", "保存", "Save"],
      ["noGoods", "请选择商品", "請選擇商品", "アイテムをお選びください", "Please select item"],
      ["look", "在线浏览", "在線瀏覽", "オンライン閲覧", "Browse Online"],
      ["downloadPdf", "下载PDF", "下載PDF", "PDFダウンロード", "Download PDF"],
      ["downloadCsv", "下载CSV", "下載CSV", "CSVダウンロード", "Download CSV"],


      ["notice", "温馨提示", "溫馨提示", "ご注意", "Notice"],
      ["uploadFail", "上传失败", "上传失败", "アップロードエラー", "Upload failed"],
      ["refuseText", "请输入拒绝说明", "請輸入拒絕說明", "拒否説明をご入力ください", "Please enter the rejecting reason"],

      ["printItem1", "订单", "訂單", "注文書", "Order"],
      ["printItem2", "收据", "收據", "領収書", "Receipt"],
      ["printItem3", "小票", "小票", "伝票", "Chit"],

      ["fileTypeErr", "添加的文件大小或格式不符合要求，请确认要求并完善信息", "添加的文件大小或格式不符合要求，請確認要求並完善信息", "添付ファイルの大きさか拡張子が要件を満たしていません。お手数ですが、ご確認の上修正してください", "The size or format of the added file does not meet the requirements. Please confirm the requirements and modify the information."],

      ["Agree", "同意", "同意", "同意", "Agree"],

      ["formInputEmptyErr", "信息填写不符合要求，请确认要求并完善信息", "信息填寫不符合要求，請確認要求並完善信息", "入力された情報が要件を満たしていません。お手数ですが、ご確認の上修正してください", "The information filled in does not meet the requirements.  Please confirm the requirements and modify the information"],

      
    ],



    "commonRule": [
      ["input_15", "请输入(15字节内)", "請輸入(15字節內)", "ご入力ください(15バイト内)", "Please enter (within 15 bytes)"],
      ["input_24", "请输入(24字节内)", "請輸入(24字節內)", "ご入力ください(24バイト内)", "Please enter (within 24 bytes)"],
      ["input_30", "请输入(30字节内)", "請輸入(30字節內)", "ご入力ください(30バイト内)", "Please enter (within 30 bytes)"],
      ["input_30_1", "请输入(30字内)", "請輸入(30字以內)", "ご入力ください(30バイト内)", "Please enter(within 60 characters)"],
      ["input_32", "请输入(32字节内)", "請輸入(32字節內)", "ご入力ください(32バイト内)", "Please enter (within 32 bytes)"],
      ["input_45", "请输入(45字节内)", "請輸入(45字節內)", "ご入力ください(45バイト内)", "Please enter (within 45 bytes)"],
      ["input_50", "请输入(50字节内)", "請輸入(50字節內)", "ご入力ください(50バイト内)", "Please enter (within 50 bytes)"],
      ["input_96", "请输入(45字内，选填)", "請輸入(45字內，選填)", "ご入力ください(45文字内、任意)", "Please enter (within 90 bytes, optional)"],
      ["input_99999", "半角整数(0~99999)", "半角整數(0~99999)", "半角整数(0~99999)", "Integer (0~99999)"],
      ["input_9999999999", "半角整数(0~9999999999)", "半角整數(0~9999999999)", "半角整数(0~9999999999)", "Integer (0~9999999999)"],
      ["input_999999999", "半角整数(0~999999999)", "半角整數(0~999999999)", "半角整数(0~999999999)", "Integer (0~999999999)"],
      ["input_99999999", "半角整数(0~99999999)", "半角整數(0~99999999)", "半角整数(0~99999999)", "Integer (0~99999999)"],
      ["input_99_9999", "半角数字(0.001~99.999)", "半角數字(0.001~99.999)", "半角数字(0.001~99.999)", "Number (0.001~99.999)"],

    ],
    "errorMsg": [
      ["loginOut", "请重新登入", "請重新登入", "再度ログインしてください", "Please login again"],
        
    ],






  }
}

export default diction



// WEBPACK FOOTER //
// ./src/lang/language.js